import {
  SubscriptionDto,
  OwnerRegistrationDto,
  ClubRegistrationDto,
  AuthDto,
  IUser,
  IAuthResponse,
  EmailVerificationDto,
  ISubscription,
  DogDto,
  IDog,
  IDogStats,
  QueryDto,
  IClub,
  EventDto,
  IEvent,
  IGateSteward,
  IEventHotel,
  EventHotelDto,
  IEventDocument,
  EventDocumentDto,
  UpdateEventDocumentDto,
  IBreed,
  IShow,
  ShowDto,
  IEventSummary,
  //EventShowsDto,
  EventRegistrationCreateDto,
  ITransactionAmounts,
  ITransactionPaymentSummary,
  IEventRegistrationResponse,
  AccountLinkDto,
  IAccountStatus,
  IShowRegistrationSummary,
  IDiscount,
  DiscountDto,
  IEventRegistration,
  EventRegistrationUpdateDto,
  UserUpdateDto,
  UpdatePasswordDto,
  IUserTransactionSummary,
  ITransactionUserSummary,
  ITransactionShowDetails,
  UserCreateDto,
  DogByClubManagerDto,
  ITransaction,
  EventRegistrationByClubManagerCreateDto,
  IScore,
  ScorePlacementDto,
  NoseworkScoreDto,
  IWeightPullWeighIn,
  DogShowClassesMoveUpDto,
  IEventMetrics,
  PasswordResetRequestDto,
  PasswordResetDto,
  TransactionRefundDto,
  IEventMessage,
  IShowRunTime,
  DuplicateEventDto,
  FastcatScoreDto,
  ICatScore,
  IShowRunTimeSlot,
  DogShowClassesDto,
  FetchScoreDto,
  IEventUKCConformationCount,
  IEventAKCConformationCount,
  RatRaceScoreDto,
  ObedienceScoreDto,
  RallyObedienceScoreDto,
  IProperty,
  ScentworkScoreDto,
  IWaitlist,
  IShowCapacityDecision,
  IUserWaitlistSummary,
  IRunningOrder,
  DockJumpingScoreDto,
  ShedDogScoreDto,
  PrecisionCoursingScoreDto,
  WeightPullScoreDto,
  FarmDogScoreDto,
  WaterDogScoreDto,
  IAddOn,
  AddOnDto,
  AgilityScoreDto,
  AkcAgilityScoreDto,
  HerdingScoreDto,
  ScentScoreDto,
  ScentDogGamesScoreDto,
  TransactionUpdateDto,
  IBulkDiscountCode,
  GenerateBulkCodesDto,
  EventRegistrationForWaitlistDto,
  CourseDto,
  ICourseDocument,
  CourseDocumentDto,
  UpdateCourseDocumentDto,
  ITariffPlan,
  ITariffPlanSubscription,
  ICourse,
  ICourseSummary,
  ITransactionAddOnDetails,
  IAddOnRegistration,
  RunningOrderDto,
  RunningOrderDogClassDto,
  IEventFullnessType,
  CourseRegistrationCreateDto,
  ITransactionCourseDogDetails,
  ICourseRegistrationResponse,
  ICourseWaitlist,
  ICourseRegistration,
  ICourseSessionRegistration,
  CourseSessionRegistrationStatusDto,
  DogProposedChangesDto,
  CreateCheckoutSessionDto,
  CreateSetupIntentDto,
  UpdateTariffPlanSubscriptionDto,
  IMoveUpSummary,
  ReverseMoveUpDto,
  ClubDonationIntentDto,
  ClubDonationDto,
  AuthJuniorDto,
  IShowCapacityMetrics,
  IIncentive,
  IncentiveDto,
  ITrustedSecretaryMetrics,
  ITrustedSecretaryReferralRow,
  ITrustedSecretaryAdminRow,
  ITrustedSecretaryClubRow,
  IConformationBreedResult,
  IConformationGroupResult,
  IConformationShowAwards,
  IConformationNonLicensedBreedResult,
  IJuniorShowmanshipResults,
} from "@eagerdog/interfaces";
import { Config } from "@eagerdog/config";
import { TitleTrackerVisibilitySettings } from "@eagerdog/constants";
import {
  IStripeInvoice,
  IStripePaymentMethod,
  IStripeSubscription,
  IStripePaymentError,
} from "@eagerdog/stripe";

import { httpService } from "./http.service";
import { localStorageService } from "./local-storage.service";
import { IFormBuildStatus } from "@eagerdog/interfaces";
import { ShowPrintParamsDto } from "@eagerdog/interfaces";
import { ShowRunTimeSlotDto } from "@eagerdog/interfaces";
import { IShowDogs } from "../routes/EventRegister/EventRegister";

export namespace apiService {
  // -------------
  const getBaseApiRoute = (): string => {
    return Config.web.REACT_APP_API_URL;
  };

  // -------------
  export const createSubscription = async (
    subscriptionDto: SubscriptionDto
  ): Promise<ISubscription> => {
    //
    const response = await httpService.post(
      `${getBaseApiRoute()}/api/subscriptions`,
      subscriptionDto
    );

    return response.data;
  };

  // -------------
  export const registerOwner = async (
    ownerRegistrationDto: OwnerRegistrationDto
  ): Promise<IUser> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/auth/owner-registration`,
      ownerRegistrationDto
    );

    return processAuthResponse(data);
  };

  // -------------
  export const registerClub = async (
    clubRegistrationDto: ClubRegistrationDto
  ): Promise<IUser> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/auth/club-registration`,
      clubRegistrationDto
    );

    return processAuthResponse(data);
  };

  // -----------------
  const processAuthResponse = (authResponse: IAuthResponse): IUser => {
    const { access_token, user } = authResponse;
    localStorageService.setItem(localStorageService.ACCESS_TOKEN, access_token);
    localStorageService.setItem(localStorageService.USER, JSON.stringify(user));

    // Dispatch event to notify components that user data has been updated
    window.dispatchEvent(new CustomEvent("userDataUpdated"));

    return user;
  };

  // -------------
  export const login = async (authDto: AuthDto): Promise<IUser> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/auth/login`,
      authDto
    );

    return processAuthResponse(data);
  };

  // -------------
  export const loginJunior = async (authDto: AuthJuniorDto): Promise<IUser> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/auth/login-junior`,
      authDto
    );

    return processAuthResponse(data);
  };

  // -------------
  export const logout = async (): Promise<void> => {
    //
    localStorageService.removeItem(localStorageService.ACCESS_TOKEN);
    localStorageService.removeItem(localStorageService.USER);
    localStorageService.removeItem(localStorageService.CAPACITIES);
    localStorageService.removeItem(localStorageService.CLUB);
    await httpService.post(`${getBaseApiRoute()}/api/auth/logout`);
  };

  // -------------
  export const verifyEmail = async (
    emailVerificationDto: EmailVerificationDto
  ): Promise<IUser> => {
    //
    const { data: user } = await httpService.post(
      `${getBaseApiRoute()}/api/auth/email-verification`,
      emailVerificationDto
    );

    localStorageService.setItem(localStorageService.USER, JSON.stringify(user));

    return user;
  };

  // -------------
  export const resendEmailVerification = async (): Promise<void> => {
    //
    await httpService.post(
      `${getBaseApiRoute()}/api/auth/resend-email-verification`
    );
  };

  // -------------
  export const whoAmI = async (): Promise<IUser> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/auth/whoami`
    );

    return data;
  };

  // -------------
  export const updateSelf = async (
    userUpdateDto: UserUpdateDto
  ): Promise<IUser> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/auth/update-user`,
      userUpdateDto
    );

    return data;
  };

  // -------------
  export const updateSelfPassword = async (
    updateUserPasswordDto: UpdatePasswordDto
  ): Promise<IUser> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/auth/update-password`,
      updateUserPasswordDto
    );

    return data;
  };

  // -------------
  export const passwordResetRequest = async (
    passwordResetRequestDto: PasswordResetRequestDto
  ): Promise<void> => {
    //
    await httpService.post(
      `${getBaseApiRoute()}/api/auth/password-reset-request`,
      passwordResetRequestDto
    );
  };

  // -------------
  export const passwordReset = async (
    passwordResetDto: PasswordResetDto
  ): Promise<void> => {
    //
    await httpService.post(
      `${getBaseApiRoute()}/api/auth/password-reset`,
      passwordResetDto
    );
  };

  // -------------
  export const emailChangeRequest = async (
    newEmail: string
  ): Promise<{ message: string }> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/auth/email-change-request`,
      { new_email: newEmail }
    );
    return data;
  };

  // -------------
  export const emailChangeVerify = async (
    verificationCode: string
  ): Promise<IUser> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/auth/email-change-verify`,
      { verification_code: verificationCode }
    );
    return data;
  };

  // ----------------
  export const getBreeds = async (query?: QueryDto): Promise<IBreed[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/breeds/actions/search`,
      query || {}
    );

    return data;
  };

  // ----------------
  export const getBreedsBySanctioningClub = async (
    sanctioningClub: string,
    query?: QueryDto
  ): Promise<IBreed[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/breeds/actions/search`,
      {
        ...query,
        query: {
          $and: [
            ...(query?.query?.$and || []),
            {
              attribute_name: "groups.name",
              attribute_value: {
                operator: "$eq",
                value: sanctioningClub,
              },
            },
          ],
        },
      }
    );

    return data;
  };

  // ----------------
  export const getBreedGroups = async (
    sanctioningClub: string,
    query?: QueryDto
  ): Promise<IProperty[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/breed-groups/${sanctioningClub}/actions/search`,
      query || {}
    );

    return data;
  };

  // ----------------
  export const getBreedsByBreedGroup = async (
    sanctioningClub: string,
    breedGroup: string,
    query?: QueryDto
  ): Promise<IBreed[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/breeds/actions/search`,
      {
        ...query,
        query: {
          $and: [
            ...(query?.query?.$and || []),
            {
              attribute_name: "groups.name",
              attribute_value: {
                operator: "$eq",
                value: sanctioningClub,
              },
            },
            {
              attribute_name: "groups.group",
              attribute_value: {
                operator: "$eq",
                value: breedGroup,
              },
            },
          ],
        },
      }
    );

    return data;
  };

  // -------------
  export const createDog = async (dogDto: DogDto): Promise<IDog> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/dogs`,
      dogDto
    );

    return data;
  };

  // -------------
  export const updateDog = async (
    dogId: string,
    dogDto: Partial<DogDto>
  ): Promise<IDog> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/dogs/${dogId}`,
      dogDto
    );

    return data;
  };

  // -------------
  export const updateDogTrackerVisibility = async (
    dogId: string,
    trackerVisibilitySettings: TitleTrackerVisibilitySettings
  ): Promise<IDog> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/dogs/${dogId}/tracker-visibility`,
      { tracker_visibility_settings: trackerVisibilitySettings }
    );

    return data;
  };

  // ----------------
  // Title Tracker / Dog Profile APIs
  // ----------------

  export const getDog = async (dogId: string): Promise<IDog> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/dogs/${dogId}`
    );
    return data;
  };

  export const getPublicDog = async (dogId: string): Promise<IDog> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/public/dog/${dogId}`
    );
    return data;
  };

  export const getRibbonRoomData = async (dogId: string): Promise<any> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/ribbon-room/dog/${dogId}`
    );
    return data;
  };

  export const getPublicRibbonRoomData = async (
    dogId: string
  ): Promise<any> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/public/dog/${dogId}/ribbon-room`
    );
    return data;
  };

  /** Stats tab (owner/admin) — includes `investment` for the current user. */
  export const getDogStats = async (dogId: string): Promise<IDogStats> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/dogs/${dogId}/stats`
    );
    return data;
  };

  /** Stats tab (public dog) — never includes `investment`. */
  export const getPublicDogStats = async (dogId: string): Promise<IDogStats> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/public/dog/${dogId}/stats`
    );
    return data;
  };

  export const getPublicDogMeta = async (dogId: string): Promise<any> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/public/dog/${dogId}/meta`
    );
    return data;
  };

  // Migration APIs
  export const migrateDogScores = async (dogId: string): Promise<any> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/admin/migration/migrate-dog/${dogId}`
    );
    return data;
  };

  // Manual Run Entry APIs
  export const createManualFastCATRun = async (runData: {
    dog_id: string;
    time_seconds: number;
    trial_date: Date;
    event_name?: string;
    location?: { city?: string; state?: string };
    notes?: string;
  }): Promise<any> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/dog-runs/fast-cat/manual`,
      runData
    );
    return data;
  };

  export const addBulkFastCATPoints = async (pointsData: {
    dog_id: string;
    points: number;
    trial_date?: Date;
  }): Promise<any> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/dog-runs/fast-cat/bulk-points`,
      pointsData
    );
    return data;
  };

  export const updateManualFastCATRun = async (
    runId: string,
    runData: {
      time_seconds?: number;
      trial_date?: Date;
      event_name?: string;
      location?: { city?: string; state?: string };
      notes?: string;
    }
  ): Promise<any> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/dog-runs/${runId}`,
      runData
    );
    return data;
  };

  export const deleteManualRun = async (runId: string): Promise<void> => {
    await httpService.delete_(`${getBaseApiRoute()}/api/dog-runs/${runId}`);
  };

  export const createManualNoseworkRun = async (runData: {
    dog_id: string;
    level: string;
    element: string;
    division: string;
    result_status: string;
    trial_date: Date;
    event_name?: string;
    location?: { city?: string; state?: string };
    notes?: string;
  }): Promise<any> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/dog-runs/manual/nosework`,
      runData
    );
    return data;
  };

  export const updateManualNoseworkRun = async (
    runId: string,
    runData: {
      level?: string;
      element?: string;
      division?: string;
      result_status?: string;
      trial_date?: Date;
      event_name?: string;
      location?: { city?: string; state?: string };
      notes?: string;
    }
  ): Promise<any> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/dog-runs/manual/nosework/${runId}`,
      runData
    );
    return data;
  };

  export const createManualScentworkRun = async (runData: {
    dogId: string;
    level: string;
    element: string;
    resultStatus: string;
    trialDate: Date;
    eventName?: string;
    location?: { city?: string; state?: string };
    notes?: string;
  }): Promise<any> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/dog-runs/manual/scentwork`,
      runData
    );
    return data;
  };

  export const updateManualScentworkRun = async (
    runId: string,
    runData: {
      level?: string;
      element?: string;
      result_status?: string;
      trial_date?: Date;
      event_name?: string;
      location?: { city?: string; state?: string };
      notes?: string;
    }
  ): Promise<any> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/dog-runs/manual/scentwork/${runId}`,
      runData
    );
    return data;
  };

  export const createManualFetchRun = async (runData: {
    dogId: string;
    level: string;
    resultStatus: string;
    trialDate: Date;
    judgeNumber?: string;
    judgeName?: string;
    eventName?: string;
    location?: { city?: string; state?: string };
    notes?: string;
  }): Promise<any> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/dog-runs/manual/fetch`,
      runData
    );
    return data;
  };

  export const updateManualFetchRun = async (
    runId: string,
    runData: {
      level?: string;
      resultStatus?: string;
      trialDate?: Date;
      judgeNumber?: string;
      judgeName?: string;
      eventName?: string;
      location?: { city?: string; state?: string };
      notes?: string;
    }
  ): Promise<any> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/dog-runs/manual/fetch/${runId}`,
      runData
    );
    return data;
  };

  export const createManualObedienceRun = async (runData: {
    dogId: string;
    obedienceClass: string;
    score: number;
    resultStatus: string;
    trialDate: Date;
    judgeNumber?: string;
    judgeName?: string;
    eventName?: string;
    location?: { city?: string; state?: string };
    notes?: string;
  }): Promise<any> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/dog-runs/manual/obedience`,
      runData
    );
    return data;
  };

  export const updateManualObedienceRun = async (
    runId: string,
    runData: {
      obedienceClass?: string;
      score?: number;
      resultStatus?: string;
      trialDate?: Date;
      judgeNumber?: string;
      judgeName?: string;
      eventName?: string;
      location?: { city?: string; state?: string };
      notes?: string;
    }
  ): Promise<any> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/dog-runs/manual/obedience/${runId}`,
      runData
    );
    return data;
  };

  export const createManualRallyRun = async (runData: {
    dogId: string;
    rallyClass: string;
    score: number;
    resultStatus: string;
    trialDate: Date;
    judgeNumber?: string;
    judgeName?: string;
    eventName?: string;
    location?: { city?: string; state?: string };
    notes?: string;
  }): Promise<any> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/dog-runs/manual/rally`,
      runData
    );
    return data;
  };

  export const updateManualRallyRun = async (
    runId: string,
    runData: {
      rallyClass?: string;
      score?: number;
      resultStatus?: string;
      trialDate?: Date;
      judgeNumber?: string;
      judgeName?: string;
      eventName?: string;
      location?: { city?: string; state?: string };
      notes?: string;
    }
  ): Promise<any> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/dog-runs/manual/rally/${runId}`,
      runData
    );
    return data;
  };

  export const createManualUKCObedienceRun = async (runData: {
    dogId: string;
    obedienceClass: string;
    score: number;
    resultStatus: string;
    trialDate: Date;
    placement?: number;
    dogsDefeated?: number;
    awards?: string[];
    judgeNumber?: string;
    judgeName?: string;
    eventName?: string;
    location?: { city?: string; state?: string };
    notes?: string;
  }): Promise<any> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/dog-runs/manual/ukc-obedience`,
      runData
    );
    return data;
  };

  export const updateManualUKCObedienceRun = async (
    runId: string,
    runData: {
      obedienceClass?: string;
      score?: number;
      resultStatus?: string;
      trialDate?: Date;
      placement?: number;
      dogsDefeated?: number;
      awards?: string[];
      judgeNumber?: string;
      judgeName?: string;
      eventName?: string;
      location?: { city?: string; state?: string };
      notes?: string;
    }
  ): Promise<any> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/dog-runs/manual/ukc-obedience/${runId}`,
      runData
    );
    return data;
  };

  export const createManualUKCRallyRun = async (runData: {
    dogId: string;
    rallyClass: string;
    score: number;
    resultStatus: string;
    trialDate: Date;
    placement?: number;
    dogsDefeated?: number;
    awards?: string[];
    judgeNumber?: string;
    judgeName?: string;
    eventName?: string;
    location?: { city?: string; state?: string };
    notes?: string;
  }): Promise<any> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/dog-runs/manual/ukc-rally`,
      runData
    );
    return data;
  };

  export const updateManualUKCRallyRun = async (
    runId: string,
    runData: {
      rallyClass?: string;
      score?: number;
      resultStatus?: string;
      trialDate?: Date;
      placement?: number;
      dogsDefeated?: number;
      awards?: string[];
      judgeNumber?: string;
      judgeName?: string;
      eventName?: string;
      location?: { city?: string; state?: string };
      notes?: string;
    }
  ): Promise<any> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/dog-runs/manual/ukc-rally/${runId}`,
      runData
    );
    return data;
  };

  export const createManualBarnHuntRun = async (runData: {
    dogId: string;
    level: string;
    section: string;
    resultStatus: string;
    time?: string;
    trialDate: Date;
    judgeNumber?: string;
    judgeName?: string;
    eventName?: string;
    location?: { city?: string; state?: string };
    notes?: string;
  }): Promise<any> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/dog-runs/manual/barn-hunt`,
      runData
    );
    return data;
  };

  export const updateManualBarnHuntRun = async (
    runId: string,
    runData: {
      level?: string;
      section?: string;
      resultStatus?: string;
      time?: string;
      trialDate?: Date;
      judgeNumber?: string;
      judgeName?: string;
      eventName?: string;
      location?: { city?: string; state?: string };
      notes?: string;
    }
  ): Promise<any> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/dog-runs/manual/barn-hunt/${runId}`,
      runData
    );
    return data;
  };

  // -------------
  export const makeDogProposedChanges = async (
    dogId: string,
    dogDto: DogProposedChangesDto
  ): Promise<IDog> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/dogs/${dogId}/proposed-changes`,
      dogDto
    );

    return data;
  };

  // -------------
  export const approveDogProposedChanges = async (
    dogId: string,
    eventId: string
  ): Promise<IDog> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/dogs/${dogId}/approve-proposed-changes/${eventId}`
    );

    return data;
  };

  // -------------
  export const getUserDogs = async (
    userId: string,
    clubId?: string
  ): Promise<IDog[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/dogs/actions/search`,
      {
        query: {
          $and: [
            {
              attribute_name: "owner_id",
              attribute_value: {
                operator: "$eq",
                value: userId,
              },
            },
            {
              attribute_name: "club_id",
              attribute_value: {
                operator: "$eq",
                value: clubId ? clubId : null,
              },
            },
          ],
        },
      }
    );

    return data;
  };

  // ----------------
  export const getClubs = async (
    query?: QueryDto
  ): Promise<{ clubs: IClub[]; metadata: { total: number } }> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/clubs/actions/search`,
      query || {}
    );

    return data;
  };

  // ----------------
  // The current user must be the club manager
  export const getCurrentClub = async (): Promise<IClub> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/current`
    );

    return data;
  };

  export const updateCurrentClub = async (
    updateData: Partial<IClub>
  ): Promise<IClub> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/clubs/current`,
      updateData
    );

    return data;
  };

  export const updateClub = async (
    clubId: string,
    updateData: Partial<IClub>
  ): Promise<IClub> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/clubs/${clubId}`,
      updateData
    );

    return data;
  };

  export const getClubVolunteerSettings = async (
    clubId: string
  ): Promise<{
    allow_late_registration: boolean;
    allow_early_registration: boolean;
  }> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/volunteer-settings`
    );
    return data;
  };

  export const updateClubVolunteerSettings = async (
    clubId: string,
    settings: {
      allow_late_registration: boolean;
      allow_early_registration: boolean;
    }
  ): Promise<IClub> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/clubs/${clubId}/volunteer-settings`,
      settings
    );
    return data;
  };

  export const updateClubDonationSettings = async (
    clubId: string,
    payload: { enable_donations: boolean; donation_amounts_preset: number[] }
  ): Promise<IClub> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/clubs/${clubId}/donation-settings`,
      payload
    );
    return data;
  };

  // ----------------
  // Get a specific club by ID (public route)
  export const getClub = async (clubId: string): Promise<IClub> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}`
    );

    return data;
  };

  // Get public events for a club (only published events)
  export const getPublicClubEvents = async (
    clubId: string,
    queryDto?: QueryDto
  ): Promise<IEventSummary[]> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${clubId}/events/public/search`,
      queryDto || {}
    );
    return data;
  };

  export const checkIfUserIsVolunteerForClub = async (
    clubId: string
  ): Promise<{ isVolunteer: boolean }> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/is-volunteer`
    );
    return data;
  };

  // -------------
  // Events
  // -------------
  // The current user must be the club manager
  export const createEvent = async (eventDto: EventDto): Promise<IEvent> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events`,
      eventDto
    );

    return data;
  };

  // -------------
  export const updateEvent = async (
    eventId: string,
    eventDto: EventDto
  ): Promise<IEvent> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}`,
      eventDto
    );

    return data;
  };

  // -------------
  export const getShowCapacityMetrics = async (
    eventId: string
  ): Promise<IShowCapacityMetrics[]> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/show-capacity-metrics`
    );
    return data;
  };

  // -------------
  // public
  export const getEventSummaryForHandle = async (
    handle: string
  ): Promise<IEventSummary> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${handle}`
    );

    return data;
  };

  // -------------
  // public route
  // export const getClubEvents = async (
  //   clubId: string,
  //   queryDto?: QueryDto
  // ): Promise<IEvent[]> => {
  //   //
  //   const { data } = await httpService.post(
  //     `${getBaseApiRoute()}/api/clubs/${clubId}/events/actions/search`,
  //     queryDto || {}
  //   );

  //   return data;
  // };

  // -------------
  // public route
  // export const getClubEvent = async (
  //   clubId: string,
  //   eventId: string
  // ): Promise<IEvent> => {
  //   //
  //   const { data } = await httpService.get(
  //     `${getBaseApiRoute()}/api/clubs/${clubId}/events/${eventId}`
  //   );

  //   return data;
  // };

  // -------------
  // Shows
  // -------------
  export const createShow = async (
    eventId: string,
    showDto: ShowDto
  ): Promise<IShow> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows`,
      showDto
    );

    return data;
  };

  // -------------
  export const updateShow = async (
    eventId: string,
    showId: string,
    showDto: ShowDto
  ): Promise<IShow> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}`,
      showDto
    );

    return data;
  };

  // -------------
  export const updateShowStatus = async (
    eventId: string,
    showId: string,
    data: { show_status: string; show_status_note?: string }
  ): Promise<IShow> => {
    //
    const { data: show } = await httpService.patch(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/status`,
      data
    );

    return show;
  };

  // -------------
  export const deleteShow = async (
    eventId: string,
    showId: string
  ): Promise<void> => {
    //
    await httpService.delete_(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}`
    );
  };

  // -------------
  export const getShowRunTimes = async (
    eventId: string,
    showId: string,
    queryDto?: QueryDto
  ): Promise<IShowRunTime[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/run-times/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // -------------
  export const getShowRunTimeSlots = async (
    eventId: string,
    showId: string,
    queryDto?: QueryDto
  ): Promise<IShowRunTimeSlot[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/run-time-slots/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // ------------------
  export const createShowRunTimeSlot = async (
    eventId: string,
    showId: string,
    timeslotDto: ShowRunTimeSlotDto
  ): Promise<IShowRunTimeSlot> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/run-time-slots`,
      timeslotDto
    );

    return data;
  };

  // ------------------
  export const bulkReplaceShowRunTimeSlots = async (
    eventId: string,
    showId: string,
    timeSlots: ShowRunTimeSlotDto[]
  ): Promise<void> => {
    await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/run-time-slots`,
      { time_slots: timeSlots }
    );
  };

  // ------------------
  export const updateShowRunTimeSlot = async (
    eventId: string,
    showId: string,
    timeslotId: string,
    timeslotDto: ShowRunTimeSlotDto
  ): Promise<IShowRunTimeSlot> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/run-time-slots/${timeslotId}`,
      timeslotDto
    );

    return data;
  };

  // ------------------
  export const deleteShowRunTimeSlot = async (
    eventId: string,
    showId: string,
    timeslotId: string
  ): Promise<void> => {
    //
    await httpService.delete_(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/run-time-slots/${timeslotId}`
    );
  };

  // -------------
  export const getShowRunningOrderSummary = async (
    eventId: string,
    showId: string,
    ring: string
  ): Promise<IRunningOrder[]> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/rings/${ring}/running-order-summary`
    );

    return data;
  };

  // -------------
  export const syncShowRingsWithScores = async (
    eventId: string,
    showId: string
  ): Promise<IShow> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/sync-rings`
    );

    return data;
  };

  // -------------
  export const updateShowRunningOrderDogClass = async (
    eventId: string,
    showId: string,
    ring: string,
    judge: string,
    queryDto: RunningOrderDogClassDto
  ): Promise<IRunningOrder[]> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/rings/${ring}/${judge}/update-dog-class`,
      queryDto
    );

    return data;
  };

  // -------------
  export const addRingRunningOrder = async (
    eventId: string,
    showId: string,
    ring: string,
    queryDto: RunningOrderDto
  ): Promise<IShow> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/rings/${ring}/add-running-order`,
      queryDto
    );

    return data;
  };

  export const updateRingRunningOrder = async (
    eventId: string,
    showId: string,
    ring: string,
    runningOrder: IRunningOrder[]
  ): Promise<IShow> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/rings/${ring}/update-running-order`,
      { running_order: runningOrder }
    );

    return data;
  };

  export const updateRingStartOffset = async (
    eventId: string,
    showId: string,
    ring: string,
    startOffsetMinutes: number
  ): Promise<IShow> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/rings/${ring}/update-running-order`,
      { start_offset_minutes: startOffsetMinutes }
    );

    return data;
  };

  export const addRingToShow = async (
    eventId: string,
    showId: string,
    ringName: string
  ): Promise<IShow> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/add-ring`,
      { ring_name: ringName }
    );

    return data;
  };

  export const deleteRingFromShow = async (
    eventId: string,
    showId: string,
    ring: string
  ): Promise<IShow> => {
    const { data } = await httpService.delete_(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/rings/${ring}`
    );

    return data;
  };

  // -------------
  // public route
  export const getClubEventShows = async (
    clubId: string,
    eventId: string,
    queryDto?: QueryDto
  ): Promise<IShow[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${clubId}/events/${eventId}/shows/actions/search`,
      queryDto || {}
    );

    return data;
  };

  export const getWaitlistedShows = async (
    eventId: string
  ): Promise<IShowDogs[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/actions/find-waitlisted`
    );

    return data;
  };

  export const getEventWaitlistedPaymentIntent = async (
    eventId: string,
    registrationDto: EventRegistrationCreateDto
  ): Promise<IEventRegistrationResponse | null> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/waitlisted-payment-intent`,
      registrationDto
    );

    return data;
  };

  export const getPublicEvents = async (
    queryDto?: QueryDto
  ): Promise<IEventSummary[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/actions/search/public`,
      queryDto || {}
    );

    return data;
  };

  // Get past public events (for dog owners viewing event history)
  export const getPastPublicEvents = async (
    queryDto?: QueryDto
  ): Promise<IEventSummary[]> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/actions/search/public/past`,
      queryDto || {}
    );

    return data;
  };

  export const getPrivateEvents = async (
    queryDto?: QueryDto,
    club_id?: string
  ): Promise<IEventSummary[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/actions/search/private`,
      { query: queryDto, club_id }
    );

    return data;
  };

  // -------------
  // Owner Events (protected route)
  export const getOwnerEvents = async (
    queryDto?: QueryDto
  ): Promise<IEventSummary[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/actions/search/owner`,
      queryDto || {}
    );

    return data;
  };
  // -------------
  // A clubs events (protected, includes published and draft events)
  export const getClubEvents = async (
    club_id: string,
    queryDto?: QueryDto
  ): Promise<IEventSummary[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${club_id}/events/actions/search`,
      queryDto || {}
    );

    return data;
  };

  export const getFullnessEvents = async (
    eventIds: string[]
  ): Promise<IEventFullnessType[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/actions/get-fullness`,
      eventIds ? { eventIds } : {}
    );

    return data;
  };

  // -------------
  // Get Current Users Clubs
  export const getCurrentUserClubs = async (): Promise<IClub> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/current`
    );

    return data;
  };

  // ---------------
  // Event registration - calculate the payment summary
  // Currently only dog owners can register dogs
  export const getRegistrationPaymentSummary = async (
    eventId: string,
    registrationDto: EventRegistrationCreateDto
  ): Promise<ITransactionPaymentSummary> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/registration-payment-summary`,
      registrationDto
    );

    const {
      account_number,
      currency,
      amount_multiplier,
      calculated_base_amount,
      calculated_discount_amount,
      calculated_application_fee,
      calculated_processing_fee,
      calculated_processing_tax,
      calculated_total_amount,
      club_points_redeemed,
      club_points_discount_amount,
      details,
      add_ons_details,
    } = data as ITransactionAmounts & { account_number: string } & {
      details: ITransactionShowDetails[];
      add_ons_details?: ITransactionAddOnDetails[];
      club_points_redeemed?: number;
      club_points_discount_amount?: number;
    };

    return {
      account_number,
      currency,
      base_amount: calculated_base_amount * amount_multiplier,
      discount: calculated_discount_amount * amount_multiplier,
      calculated_application_fee,
      calculated_processing_fee,
      calculated_processing_tax,
      fees:
        (calculated_application_fee +
          calculated_processing_fee +
          calculated_processing_tax) *
        amount_multiplier,
      total_amount: calculated_total_amount * amount_multiplier,
      club_points_redeemed,
      club_points_discount_amount,
      details,
      add_ons_details,
    };
  };

  export const createIncentive = async (
    eventId: string,
    incentiveDto: IncentiveDto
  ): Promise<IIncentive> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/incentives`,
      incentiveDto
    );

    return data;
  };

  export const getIncentive = async (eventId: string): Promise<IIncentive> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/incentives`
    );

    return data;
  };

  export const updateIncentive = async (
    eventId: string,
    incentiveId: string,
    incentiveDto: IncentiveDto
  ): Promise<IIncentive> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/incentives/${incentiveId}`,
      incentiveDto
    );

    return data;
  };

  export const deleteIncentive = async (
    eventId: string,
    incentiveId: string
  ): Promise<void> => {
    await httpService.delete_(
      `${getBaseApiRoute()}/api/events/${eventId}/incentives/${incentiveId}`
    );
  };

  // ---------------
  // Stripe link to onboard the account
  // The FE needs to provide the return/refresh urls
  export const getAccountOnboardingLink = async (
    clubId: string,
    accountLinkDto: AccountLinkDto
  ): Promise<{ url: string }> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${clubId}/account-link`,
      accountLinkDto
    );

    return data;
  };

  // ---------------
  // Stripe link to onboard the account
  // The FE needs to provide the return/refresh urls
  export const getAccountStatus = async (
    clubId: string
  ): Promise<IAccountStatus> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/account-status`
    );

    return data;
  };

  // ---------------
  // Get Stripe balance for a club account
  export const getStripeBalance = async (clubId: string): Promise<any> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/stripe/balance`
    );
    return data;
  };

  // ---------------
  // Get Stripe balance transactions for a club account
  export const getStripeBalanceTransactions = async (
    clubId: string,
    startDate?: string,
    endDate?: string
  ): Promise<any[]> => {
    const params: Record<string, string> = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    const query = new URLSearchParams(params).toString();
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/stripe/balance-transactions${query ? `?${query}` : ""}`
    );
    return data;
  };

  // ---------------
  // Get Stripe payouts for a club account
  export const getStripePayouts = async (clubId: string): Promise<any[]> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/stripe/payouts`
    );
    return data;
  };

  // ---------------
  // Get Stripe payout transactions for a specific payout
  export const getPayoutTransactions = async (
    clubId: string,
    payoutId: string
  ): Promise<any[]> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/stripe/payouts/${payoutId}/transactions`
    );
    return data;
  };

  // ---------------
  // Get transactions by charge IDs
  export const getTransactionsByChargeIds = async (
    clubId: string,
    chargeIds: string[]
  ): Promise<any[]> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${clubId}/transactions/by-charge-ids`,
      { charge_ids: chargeIds }
    );
    return data;
  };

  // ---------------
  // Get Stripe payout schedule for a club account
  export const getStripePayoutSchedule = async (
    clubId: string
  ): Promise<any> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/stripe/payout-schedule`
    );
    return data;
  };

  // ---------------
  // Get Stripe refunds for a club account
  export const getStripeRefunds = async (
    clubId: string,
    limit?: number,
    startingAfter?: string
  ): Promise<{ refunds: any[]; hasMore: boolean }> => {
    const params = new URLSearchParams();
    if (limit) params.append("limit", limit.toString());
    if (startingAfter) params.append("starting_after", startingAfter);

    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/stripe/refunds?${params.toString()}`
    );
    return data;
  };

  // ---------------
  // Cancel a Stripe refund
  export const cancelStripeRefund = async (
    clubId: string,
    refundId: string
  ): Promise<any> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${clubId}/stripe/refunds/${refundId}/cancel`
    );
    return data;
  };

  // ---------------
  // Get Stripe refund details
  export const getStripeRefundDetails = async (
    clubId: string,
    refundId: string
  ): Promise<any> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/stripe/refunds/${refundId}`
    );
    return data;
  };

  // ---------------
  // Update Stripe payout schedule for a club account
  export const updateStripePayoutSchedule = async (
    clubId: string,
    schedule: {
      interval: string;
      delay_days: number;
      weekly_anchor?: string;
      monthly_anchor?: number;
    }
  ): Promise<any> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${clubId}/stripe/payout-schedule`,
      schedule
    );
    return data;
  };

  // ---------------
  // Request manual payout for a club account
  export const requestManualPayout = async (
    clubId: string,
    payoutRequest: {
      amount: number;
      currency: string;
      description?: string;
    }
  ): Promise<any> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${clubId}/stripe/manual-payout`,
      payoutRequest
    );
    return data;
  };

  // ---------------
  // Request instant payout for a club account
  export const requestInstantPayout = async (
    clubId: string,
    payoutRequest: {
      amount: number;
      currency: string;
      description?: string;
    }
  ): Promise<any> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${clubId}/stripe/instant-payout`,
      payoutRequest
    );
    return data;
  };

  // ---------------
  // Event registration - calculate the payment summary
  // Currently only dog owners can register dogs.
  // null is returned in case of "manual" registration (not supported currently)
  export const createRegistrationPaymentIntent = async (
    eventId: string,
    registrationDto: EventRegistrationCreateDto
  ): Promise<IEventRegistrationResponse | null> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/registrations`,
      registrationDto
    );

    return data;
  };

  // ---------------
  // Triggered when Stripe redirects back with redirect_status=processing after a
  // bank account payment. Creates dog registrations immediately without waiting for the webhook.
  export const processBankPaymentReturn = async (
    eventId: string,
    paymentIntentId: string
  ): Promise<void> => {
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/transactions/actions/process-bank-payment-return`,
      { payment_intent_id: paymentIntentId }
    );
  };

  // ---------------
  // Event registration - calculate the payment summary
  // Currently only dog owners can register dogs.
  // null is returned in case of "manual" registration (not supported currently)
  export const createRegistrationByClubManager = async (
    eventId: string,
    registrationDto: EventRegistrationByClubManagerCreateDto
  ): Promise<ITransaction> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/registrations-by-club-manager`,
      registrationDto
    );

    return data;
  };

  export const returnScoreToWaitlist = async (
    eventId: string,
    scoreId: string
  ): Promise<void> => {
    //
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/score/${scoreId}/return`
    );
  };

  export const returnShowRegistrationToWaitlist = async (
    eventId: string,
    showRegistrationId: string
  ): Promise<void> => {
    //
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/show-registrations/${showRegistrationId}/return`
    );
  };

  export const returnAwaitingWaitlistToWaitlist = async (
    eventId: string,
    waitlistId: string
  ): Promise<void> => {
    //
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/waitlists/${waitlistId}/return`
    );
  };

  // -----------------
  export const runLotteryEvent = async (
    eventId: string
  ): Promise<IEventSummary> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/lottery/run`
    );

    return data;
  };

  // -----------------
  export const declineLotteryInvite = async (
    eventId: string
  ): Promise<void> => {
    //
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/lottery/decline-invite`
    );
  };

  // -----------------
  export const declineWaitlistedInvite = async (
    eventId: string
  ): Promise<void> => {
    //
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/waitlisted/decline-invite`
    );
  };

  // -----------------
  export const inviteLotteryWaitlist = async (
    eventId: string,
    waitlistId: string
  ): Promise<IWaitlist> => {
    //
    return await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/waitlists/${waitlistId}/lottery/invite`
    );
  };

  // -----------------
  export const rejectLotteryWaitlist = async (
    eventId: string,
    waitlistId: string
  ): Promise<void> => {
    //
    return await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/waitlists/${waitlistId}/lottery/reject`
    );
  };

  // -----------------
  export const processOwnerRegistrationTransaction = async (
    eventId: string,
    transactionId: string,
    registrationDto: EventRegistrationForWaitlistDto
  ): Promise<void> => {
    //
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/transactions/${transactionId}/actions/process`,
      registrationDto
    );
  };

  // ---------------
  // Event registration - calculate the payment summary
  // Currently only dog owners can register dogs.
  // null is returned in case of "manual" registration (not supported currently)
  export const approveWaitlistForRegistration = async (
    eventId: string,
    waitlistId: string
  ): Promise<IWaitlist> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/waitlists/${waitlistId}/approve`
    );

    return data;
  };

  export const getWaitlistsPendingForUser = async (
    eventId: string,
    userId: string
  ): Promise<IWaitlist[]> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/waitlists/pending-for-user?user_id=${userId}`
    );
    return data;
  };

  export interface IBatchApproveResult {
    approved: string[];
    skipped: string[];
    /** Entries skipped because the show is full, keyed by waitlist id. */
    over_capacity: Record<string, IShowCapacityDecision>;
    /** dry_run only: one capacity decision per show for the requested entries. */
    capacity?: IShowCapacityDecision[];
  }

  export const batchApproveWaitlists = async (
    eventId: string,
    waitlistIds: string[],
    options?: { allow_over_capacity?: boolean; dry_run?: boolean }
  ): Promise<IBatchApproveResult> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/waitlists/batch-approve`,
      { waitlist_ids: waitlistIds, ...(options || {}) }
    );
    return data;
  };

  export const resendWaitlistApprovalEmail = async (
    eventId: string,
    waitlistId: string
  ): Promise<void> => {
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/waitlists/${waitlistId}/resend-approval-email`
    );
  };

  export const resendLotteryConfirmationEmail = async (
    eventId: string,
    waitlistId: string
  ): Promise<void> => {
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/waitlists/${waitlistId}/resend-lottery-confirmation-email`
    );
  };

  // -----------------
  export const previewApproveWaitlistWithoutPayment = async (
    eventId: string,
    waitlistId: string
  ): Promise<IWaitlist[]> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/waitlists/${waitlistId}/approve-without-payment/preview`
    );

    return data;
  };

  // -------------
  export const editRunningOrderJudge = async (
    eventId: string,
    showId: string,
    ring: string,
    payload: {
      old_judge_name: string;
      old_judge_number?: string;
      judge_name: string;
      judge_number?: string;
    }
  ): Promise<IShow> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/rings/${ring}/edit-running-order-judge`,
      payload
    );
    return data;
  };

  // -----------------
  export const approveWaitlistWithoutPayment = async (
    eventId: string,
    waitlistId: string,
    waitlistIds?: string[],
    allowOverCapacity?: boolean
  ): Promise<void> => {
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/waitlists/${waitlistId}/approve-without-payment`,
      {
        ...(waitlistIds?.length ? { waitlist_ids: waitlistIds } : {}),
        ...(allowOverCapacity ? { allow_over_capacity: true } : {}),
      }
    );
  };

  // ------------------
  // Event admins to cancel/deny a waitlist entry
  export const updateWaitlistDateReceived = async (
    eventId: string,
    waitlistId: string,
    dateReceived: Date
  ): Promise<IWaitlist> => {
    const { data } = await httpService.patch(
      `${getBaseApiRoute()}/api/events/${eventId}/waitlists/${waitlistId}`,
      { date_received: dateReceived }
    );
    return data;
  };

  // ------------------
  export const cancelEventWaitlistEntry = async (
    eventId: string,
    waitlistId: string
  ): Promise<IWaitlist> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/waitlists/${waitlistId}/actions/cancel`
    );

    return data;
  };

  // ------------------
  // Event admins to delete a waitlist entry
  export const deleteEventWaitlistEntry = async (
    eventId: string,
    waitlistId: string
  ) => {
    //
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/waitlists/${waitlistId}/actions/delete`
    );
  };

  // ------------------
  // Event admins to cancel/deny all remaining waitlist entries in "waitlist" status
  export const cancelEventWaitlistEntries = async (
    eventId: string
  ): Promise<void> => {
    //
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/waitlists/actions/cancel`
    );
  };

  // ------------------
  // User to withdraw/cancel his own waitlist entry
  // The waitlist entry must belong to the current user
  export const cancelUserWaitlistEntry = async (
    waitlistId: string
  ): Promise<IUserWaitlistSummary> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/users/waitlists/${waitlistId}/cancel`
    );

    return data;
  };

  export const cancelUserRegistration = async (body: {
    show_registration_id: string;
    show_element: string;
    level?: string;
    section?: string;
  }): Promise<{ refund_amount_cents: number; pending?: boolean }> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/users/registrations/actions/cancel`,
      body
    );
    return data;
  };

  // ---------------
  export const getEventRefundRequests = async (
    eventId: string
  ): Promise<any[]> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/refund-requests`
    );
    return data;
  };

  // ---------------
  export const updateAllowRefundsWithoutApproval = async (
    eventId: string,
    allow: boolean
  ): Promise<void> => {
    await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/settings/allow-refunds-without-approval`,
      { allow_refunds_without_approval: allow }
    );
  };

  // ---------------
  export const approveRefundRequest = async (
    eventId: string,
    requestId: string,
    options: {
      remove_entry?: boolean;
      amount?: number;
      entry_amount?: number;
    } = {}
  ): Promise<any> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/refund-requests/${requestId}/actions/approve`,
      {
        remove_entry: options.remove_entry ?? false,
        amount: options.amount,
        entry_amount: options.entry_amount,
      }
    );
    return data;
  };

  // ---------------
  export const denyRefundRequest = async (
    eventId: string,
    requestId: string,
    denialReason?: string
  ): Promise<any> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/refund-requests/${requestId}/actions/deny`,
      { denial_reason: denialReason }
    );
    return data;
  };

  // ---------------
  export const generateArmNumbersPerShowType = async (
    eventId: string
  ): Promise<void> => {
    //
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/show-type-arm-numbers`
    );
  };

  // ---------------
  export const resetArmNumbers = async (eventId: string): Promise<void> => {
    //
    await httpService.delete_(
      `${getBaseApiRoute()}/api/events/${eventId}/arm-numbers`
    );
  };

  // ---------------
  export const generatedArmNumbersPerShowTypeEmails = async (
    eventId: string,
    isTestSending?: boolean,
    testRecipientEmail?: string,
    testTargetUserId?: string
  ): Promise<void> => {
    //
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/show-type-arm-numbers-emails`,
      {
        is_test_sending: isTestSending,
        test_recipient_email: testRecipientEmail,
        test_target_user_id: testTargetUserId,
      }
    );
  };

  // ---------------
  export const getNextArmbandNumber = async (
    eventId: string,
    options?: { showType?: string; dogId?: string }
  ): Promise<{
    next_armband_number: string;
    next_armband_numbers_by_group?: Array<{
      breed_group: string;
      range_start: number;
      range_end: number;
      next_armband_number: string;
    }>;
    existing_armband_number?: string;
    existing_runs_count?: number;
  }> => {
    //
    const params = new URLSearchParams();
    if (options?.showType) params.set("show_type", options.showType);
    if (options?.dogId) params.set("dog_id", options.dogId);
    const query = params.toString();
    const response = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/next-armband-number${query ? `?${query}` : ""}`
    );

    return response.data;
  };

  // ---------------
  export const assignArmbandNumber = async (
    eventId: string,
    showId: string,
    dogId: string,
    armbandNumber: string,
    isJunior?: boolean
  ): Promise<void> => {
    //
    await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/dogs/${dogId}/armband`,
      { armband_number: armbandNumber, is_junior: isJunior }
    );
  };

  // ---------------
  // Assign/edit the armband number for a single run (score) only - used on
  // the Entries / Results tab. Unlike assignArmbandNumber above, this never
  // affects the dog's other runs/registrations for the event.
  export const assignScoreArmbandNumber = async (
    eventId: string,
    scoreId: string,
    armbandNumber: string,
    isJunior?: boolean
  ): Promise<void> => {
    //
    await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/armband`,
      { armband_number: armbandNumber, is_junior: isJunior }
    );
  };

  // ----------------
  // Protected route - club managers can view the event registrations
  export const getEventRegistrations = async (
    eventId: string,
    queryDto?: QueryDto
  ): Promise<IEventRegistration[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/registrations/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // ----------------
  // Protected route - club managers can view the event registrations
  export const updateShowRegistration = async (
    eventId: string,
    registrationId: string,
    updateDto: EventRegistrationUpdateDto
  ): Promise<IEventRegistration> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/show-registrations/${registrationId}`,
      updateDto
    );

    return data;
  };

  // ----------------
  /**
   * @deprecated The method should not be used anymore
   */
  // export const dogClassesMoveUp = async (
  //   eventId: string,
  //   showRegistrationId: string,
  //   updateDto: DogShowClassesMoveUpDto
  // ): Promise<IEventRegistration> => {
  //   //
  //   const { data } = await httpService.put(
  //     `${getBaseApiRoute()}/api/events/${eventId}/show-registrations/${showRegistrationId}/classes-moveup`,
  //     updateDto
  //   );

  //   return data;
  // };

  // ----------------
  export const dogClassMoveUp = async (
    eventId: string,
    moveUpClasses: DogShowClassesMoveUpDto
  ): Promise<void> => {
    //
    await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/class-moveup`,
      moveUpClasses
    );
  };

  // ----------------
  // Move-Up Management
  // ----------------

  export const getEventMoveUps = async (
    eventId: string
  ): Promise<IMoveUpSummary[]> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/move-ups`
    );
    return data;
  };

  export const reverseMoveUp = async (
    eventId: string,
    moveUpId: string,
    reason?: string
  ): Promise<void> => {
    const dto: ReverseMoveUpDto = { reason };
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/move-ups/${moveUpId}/reverse`,
      dto
    );
  };

  // ----------------
  export const dogClassUpdates = async (
    eventId: string,
    classUpdates: DogShowClassesDto
  ): Promise<void> => {
    //
    await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/class-updates`,
      classUpdates
    );
  };

  // ----------------
  export const dogClassUpdatesAKC = async (
    eventId: string,
    classUpdates: DogShowClassesDto
  ): Promise<void> => {
    //
    await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/class-updates-akc`,
      classUpdates
    );
  };

  // ---------------
  export const getRegisteredDogsByCurrentUser = async (
    eventId: string,
    queryDto?: QueryDto
  ): Promise<IDog[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/registered-dogs/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // ----------------
  // Protected route - club managers can view registrations (to discuss?)
  export const getEventShowRegistrations = async (
    eventId: string,
    queryDto?: QueryDto
  ): Promise<IShowRegistrationSummary[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/show-registrations/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // ----------------
  export const getEventWaitlists = async (
    eventId: string,
    queryDto?: QueryDto
  ): Promise<IWaitlist[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/waitlists/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // ----------------
  export const getUserWaitlists = async (
    userId: string,
    queryDto?: QueryDto
  ): Promise<IUserWaitlistSummary[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/users/${userId}/waitlists/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // ----------------
  // Combined endpoint for user registrations (both show_registrations and waitlist)
  export const getUserRegistrations = async (
    userId: string,
    queryDto?: QueryDto
  ): Promise<IUserWaitlistSummary[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/users/${userId}/registrations/actions/search`,
      queryDto || {}
    );

    return data;
  };

  export interface IUserEntriesPage {
    items: IUserWaitlistSummary[];
    total: number;
    dogs: { id: string; call_name: string }[];
    events: { id: string; title: string }[];
    statuses: string[];
  }

  export const searchUserEntries = async (
    userId: string,
    body: {
      period: "upcoming" | "past";
      dog_id?: string;
      event_id?: string;
      status?: string;
      $skip: number;
      $limit: number;
      today: string;
    }
  ): Promise<IUserEntriesPage> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/users/${userId}/registrations/actions/search-page`,
      body
    );

    return data;
  };

  // ----------------
  export const getOwnerScores = async (
    queryDto?: QueryDto
  ): Promise<IScore[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/users/owner/scores/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // -----------------
  export const removeDogFromShow = async (
    eventId: string,
    showId: string,
    dogId: string
  ): Promise<void> => {
    //
    await httpService.delete_(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/dogs/${dogId}`
    );
  };

  // ----------------
  export const getEventDiscounts = async (
    eventId: string,
    queryDto?: QueryDto
  ): Promise<IDiscount[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/discounts/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // ----------------
  export const createEventDiscount = async (
    eventId: string,
    discountDto: DiscountDto
  ): Promise<IDiscount> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/discounts`,
      discountDto
    );

    return data;
  };

  // ----------------
  export const updateEventDiscount = async (
    eventId: string,
    discountId: string,
    discountDto: DiscountDto
  ): Promise<IDiscount> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/discounts/${discountId}`,
      discountDto
    );

    return data;
  };

  // ----------------
  export const deleteEventDiscount = async (
    eventId: string,
    discountId: string
  ): Promise<void> => {
    //
    await httpService.delete_(
      `${getBaseApiRoute()}/api/events/${eventId}/discounts/${discountId}`
    );
  };

  // ----------------
  export const getEventTransactions = async (
    eventId: string,
    queryDto?: QueryDto
  ): Promise<ITransactionUserSummary[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/transactions/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // ----------------
  export const refundEventTransaction = async (
    eventId: string,
    transactionId: string,
    refundDto: TransactionRefundDto
  ): Promise<void> => {
    //
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/transactions/${transactionId}/actions/refund`,
      refundDto
    );
  };

  // ----------------
  export const markTransactionAsPaid = async (
    eventId: string,
    transactionId: string,
    body: { payment_method_type?: string; cheque_number?: string }
  ): Promise<void> => {
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/transactions/${transactionId}/actions/mark-paid`,
      body
    );
  };

  // ----------------
  export const cancelUnpaidTransaction = async (
    eventId: string,
    transactionId: string
  ): Promise<void> => {
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/transactions/${transactionId}/actions/cancel-unpaid`,
      {}
    );
  };

  // ----------------
  export const cancelUnpaidTransactionSelf = async (
    eventId: string,
    transactionId: string
  ): Promise<void> => {
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/transactions/${transactionId}/actions/cancel-unpaid-self`,
      {}
    );
  };

  // ----------------
  export const getUnpaidTransactionCount = async (
    eventId: string
  ): Promise<{ count: number }> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/transactions/unpaid-count`
    );
    return data;
  };

  // ----------------
  export const getRequestedRefundCount = async (
    eventId: string
  ): Promise<{ count: number }> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/refund-requests/requested-count`
    );
    return data;
  };

  // ----------------
  export const updateEventTransaction = async (
    eventId: string,
    transactionId: string,
    updateDto: TransactionUpdateDto
  ): Promise<void> => {
    //
    await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/transactions/${transactionId}`,
      updateDto
    );
  };

  // ----------------
  export const createPaymentRequest = async (
    eventId: string,
    transactionId: string,
    body: { new_total: number; note?: string; full_amount?: boolean }
  ): Promise<{ supplemental_transaction_id: string }> => {
    const response = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/transactions/${transactionId}/payment-request`,
      body
    );
    return response.data;
  };

  // ----------------
  export const resendPaymentRequest = async (
    eventId: string,
    transactionId: string
  ): Promise<void> => {
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/transactions/${transactionId}/resend-payment-request`,
      {}
    );
  };

  // ----------------
  export const cancelPaymentRequest = async (
    eventId: string,
    transactionId: string
  ): Promise<void> => {
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/transactions/${transactionId}/cancel-payment-request`,
      {}
    );
  };

  // ----------------
  export const findPaymentRequests = async (
    eventId: string
  ): Promise<{ transaction: any; original_transaction: any }[]> => {
    const response = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/actions/find-payment-requests`,
      {}
    );
    return response.data;
  };

  // ----------------
  export const getPaymentRequestIntent = async (
    eventId: string,
    transactionId: string
  ): Promise<{ client_secret: string; payment_intent_id: string; account_number: string; currency: string; delta_cents: number }> => {
    const response = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/transactions/${transactionId}/payment-request-intent`,
      {}
    );
    return response.data;
  };

  // ----------------
  export const getEventMetrics = async (
    eventId: string
  ): Promise<IEventMetrics> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/metrics`
    );

    return data;
  };

  // ----------------
  // Public event metrics for dog owners viewing past events
  export const getEventMetricsPublic = async (
    eventId: string
  ): Promise<{ dogs: number; entries: number; distinctBreeds: number }> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/metrics/public`
    );

    return data;
  };

  // ----------------
  export const getUserTransactions = async (
    userId: string,
    queryDto?: QueryDto
  ): Promise<IUserTransactionSummary[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/users/${userId}/transactions/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // --------------
  export const requestEntryForms = async (
    eventId: string,
    dogId: string,
    sendEmail?: boolean,
    payload?: IEventMessage
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/dogs/${dogId}/forms/entry-form${
        sendEmail ? "?email=true" : ""
      }`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return data;
  };

  // --------------
  export const requestEntryFormsForEvent = async (
    eventId: string,
    showTypes?: string[]
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/entry-form`,
      {
        params:
          showTypes && showTypes.length > 0
            ? { show_types: showTypes.join(",") }
            : undefined,
      }
    );

    return data;
  };

  // --------------
  export const requestRegistrationSummary = async (
    eventId: string,
    userId: string,
    includeWaitlist?: boolean
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/users/${userId}/forms/registration-summary`,
      { params: { include_waitlist: includeWaitlist ?? true } }
    );

    return data;
  };

  // --------------
  export const sendRegistrationSummary = async (
    eventId: string,
    userId: string,
    payload: IEventMessage,
    includeWaitlist?: boolean
  ): Promise<void> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/users/${userId}/send-registration-summary`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: { include_waitlist: includeWaitlist ?? true },
      }
    );

    return data;
  };

  // --------------
  export const searchRegisteredUsersForTest = async (
    eventId: string,
    query: string
  ): Promise<
    Array<{ user_id: string; display_name: string; email: string }>
  > => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/registered-users/search`,
      { params: { q: query } }
    );
    return data;
  };

  // --------------
  export const requestEntryFormsForTransaction = async (
    transactionId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/transactions/${transactionId}/forms/entry-form`
    );

    return data;
  };

  // --------------
  export const downloadStoreReceipt = async (
    transactionId: string
  ): Promise<Blob> => {
    const response = await httpService.get(
      `${getBaseApiRoute()}/api/transactions/${transactionId}/receipt`,
      { responseType: "blob" }
    );

    return response.data;
  };

  // --------------
  export const requestJudgeBooks = async (
    eventId: string,
    showId: string,
    params?: ShowPrintParamsDto
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/forms/judge-books`,
      params
    );

    return data;
  };

  // --------------
  export const requestJudgeBreeds = async (
    eventId: string,
    showId: string,
    params?: ShowPrintParamsDto
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/forms/judge-breeds`,
      params
    );

    return data;
  };

  // --------------
  export const requestEventJudgeBreeds = async (
    eventId: string
  ): Promise<IFormBuildStatus> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/judge-breeds`
    );

    return data;
  };

  // --------------
  // Run-offs
  export const getRunOffs = async (
    eventId: string,
    showId: string
  ): Promise<{ run_offs: any[] }> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/run-offs`
    );
    return data;
  };

  export const updateRunOffWinner = async (
    eventId: string,
    showId: string,
    runOffIndex: number,
    body: {
      winner_arm_number: string;
      show_element: string;
      level: string;
      placement: string;
      ordered_placements?: Array<{
        arm_number: string;
        dog_name: string;
        score_id: string;
        placement: number;
      }>;
    }
  ): Promise<{ run_off: any }> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/run-offs/${runOffIndex}/winner`,
      body
    );
    return data;
  };

  // --------------
  export const requestScoresheets = async (
    eventId: string,
    showId: string,
    params?: ShowPrintParamsDto
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/forms/scoresheets`,
      params
    );

    return data;
  };

  // --------------
  export const requestShowScoresheet = async (
    eventId: string,
    showId: string
  ): Promise<IFormBuildStatus> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/scoresheet`
    );
    return data;
  };

  // --------------
  export const requestShowSecretaryCertification = async (
    eventId: string,
    showId: string
  ): Promise<IFormBuildStatus> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/secretary-certification`
    );
    return data;
  };

  // --------------
  export const requestIndividualScoresheets = async (
    eventId: string,
    showId: string,
    scoreId: string,
    params?: ShowPrintParamsDto
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/score/${scoreId}/forms/scoresheets`,
      params
    );

    return data;
  };

  // --------------
  // Event-level (not per-trial) — see docs/ukc-weight-pull-weigh-in-redesign.md.
  export const requestEventWeighInForms = async (
    eventId: string
  ): Promise<IFormBuildStatus> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/weigh-in-forms`
    );

    return data;
  };

  // --------------
  export const requestEventScoresheets = async (
    eventId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/scoresheets`
    );

    return data;
  };

  // --------------
  export const requestEventScoresheetsCondensed = async (
    eventId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/scoresheets-condensed`
    );

    return data;
  };

  // --------------
  export const requestEventJudgeScheduleCalculator = async (
    eventId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/judge-schedule-calculator`
    );

    return data;
  };

  // --------------
  export const requestRegistrationListForEvent = async (
    eventId: string,
    options?: { selected_columns?: string[] }
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/registration-list`,
      options || {}
    );

    return data;
  };

  // ----------------
  export const requestClubContactsExport = async (
    clubId: string,
    capacityFilters?: string[]
  ): Promise<IFormBuildStatus> => {
    const params = new URLSearchParams();

    if (capacityFilters && capacityFilters.length > 0) {
      capacityFilters.forEach((filter) => {
        params.append("capacity", filter);
      });
    }

    const queryString = params.toString();
    const url = `${getBaseApiRoute()}/api/clubs/${clubId}/capacities/export${queryString ? "?" + queryString : ""}`;

    const { data } = await httpService.get(url);

    return data;
  };

  // ----------------
  export const requestClubStoreTransactionsExport = async (
    clubId: string
  ): Promise<IFormBuildStatus> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/store/transactions/export`
    );

    return data;
  };

  // --------------
  export const requestScoresListForEvent = async (
    eventId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/scores-list`
    );

    return data;
  };

  // --------------
  export const requestEventTransactions = async (
    eventId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/transaction-list`
    );
    return data;
  };

  // --------------
  export const requestEventTransactionsSummary = async (
    eventId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/transaction-summary`
    );
    return data;
  };

  // --------------
  export const requestEventWaitlists = async (
    eventId: string,
    showId?: string
  ): Promise<IFormBuildStatus> => {
    //
    const url = showId
      ? `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/forms/waitlist-list`
      : `${getBaseApiRoute()}/api/events/${eventId}/forms/waitlist-list`;
    const { data } = await httpService.get(url);
    return data;
  };

  // --------------
  export const requestCounts = async (
    eventId: string,
    showId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/${showId}/show-registrations/counts`
    );
    return data;
  };

  // --------------
  export const requestCountsFormatted = async (
    eventId: string,
    showId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/${showId}/show-registrations/counts-formatted`
    );
    return data;
  };

  // --------------
  export const requestScoreListForShowType = async (
    eventId: string,
    showType: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/score-list/${showType}`
    );

    return data;
  };

  // --------------
  /**
   *
   * @param eventId
   * @param showId In case of AKC fetch use "*" for showId
   * @param params
   * @returns
   */
  export const requestShowCheckinLists = async (
    eventId: string,
    showId: string,
    params?: ShowPrintParamsDto
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/forms/checkin-lists`,
      params
    );

    return data;
  };

  // --------------
  export const requestShowRingSheets = async (
    eventId: string,
    showId: string,
    params?: ShowPrintParamsDto
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/forms/ring-sheets`,
      params
    );

    return data;
  };

  // --------------
  export const requestShowResultLists = async (
    eventId: string,
    showId: string,
    params?: ShowPrintParamsDto
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/forms/results`,
      params
    );

    return data;
  };

  // --------------
  export const requestCwagsScentResults = async (
    eventId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/scent-results`
    );

    return data;
  };

  // --------------
  export const requestBarnHuntResults = async (
    eventId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/barn-hunt-results`
    );

    return data;
  };

  // --------------
  export const requestFastCatResultsDetailed = async (
    eventId: string
  ): Promise<IFormBuildStatus> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/fast-cat-results-detailed`
    );

    return data;
  };

  // --------------
  export const requestEventArmbandLabels = async (
    eventId: string,
    params?: { labels_to_skip?: number; show_ids?: string[]; arm_numbers?: number[] }
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/armband-labels`,
      params
    );

    return data;
  };

  // --------------
  export const requestEventArmbandLabelsBack = async (
    eventId: string,
    params?: { labels_to_skip?: number; show_ids?: string[]; arm_numbers?: number[] }
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/armband-labels-back`,
      params
    );

    return data;
  };

  // --------------
  export const requestEventArmbandLabels5919 = async (
    eventId: string,
    params?: { labels_to_skip?: number; show_ids?: string[]; arm_numbers?: number[] }
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/armband-labels-5919`,
      params
    );

    return data;
  };

  // --------------
  export const requestEventArmbandLabels5919Detail = async (
    eventId: string,
    params?: { labels_to_skip?: number; show_ids?: string[]; arm_numbers?: number[] }
  ): Promise<IFormBuildStatus> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/armband-labels-5919-detail`,
      params
    );
    return data;
  };

  // --------------
  export const requestEventArmbandLabels5162 = async (
    eventId: string,
    params?: { labels_to_skip?: number; show_ids?: string[]; arm_numbers?: number[] }
  ): Promise<IFormBuildStatus> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/armband-labels-5162`,
      params
    );
    return data;
  };

  // --------------
  export const requestEventArmbandLabels5919Back = async (
    eventId: string,
    params?: { labels_to_skip?: number; show_ids?: string[]; arm_numbers?: number[] }
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/armband-labels-5919-back`,
      params
    );

    return data;
  };

  // --------------
  export const requestEventArmbandLabels5164 = async (
    eventId: string,
    params?: { labels_to_skip?: number; show_ids?: string[]; arm_numbers?: number[] }
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/armband-labels-5164`,
      params
    );

    return data;
  };

  // -------------
  export const requestEventArmbandLabels5164Back = async (
    eventId: string,
    params?: { labels_to_skip?: number; show_ids?: string[]; arm_numbers?: number[] }
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/armband-labels-5164-back`,
      params
    );

    return data;
  };

  // --------------
  export const requestEventArmbandLabels3PerPage = async (
    eventId: string,
    params?: { labels_to_skip?: number; show_ids?: string[]; arm_numbers?: number[] }
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/armband-labels-3perpage`,
      params
    );

    return data;
  };

  // --------------
  export const requestEventArmbandLabels4PerPage = async (
    eventId: string,
    params?: { labels_to_skip?: number; show_ids?: string[]; arm_numbers?: number[] }
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/armband-labels-4perpage`,
      params
    );

    return data;
  };

  // --------------
  export const requestResultRibbonLabels = async (
    eventId: string,
    showId: string,
    params?: ShowPrintParamsDto & { labels_to_skip?: number }
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/forms/ribbon-labels`,
      params
    );

    return data;
  };

  // --------------
  export const requestScoresheetLabels = async (
    eventId: string,
    showId: string,
    params?: ShowPrintParamsDto & { labels_to_skip?: number }
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/forms/scoresheet-labels`,
      params
    );

    return data;
  };

  // --------------
  export const requestResultsEmailForEvent = async (
    eventId: string,
    payload: IEventMessage
  ): Promise<void> => {
    //
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/results-email`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  };

  // --------------
  export const requestResultsEmailForShow = async (
    eventId: string,
    showId: string,
    payload: IEventMessage
  ): Promise<void> => {
    //
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/forms/results-email`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  };

  // --------------
  export const requestResultsEmailForShowRegistration = async (
    eventId: string,
    scoreId: string,
    payload: IEventMessage
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/forms/results-email`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return data;
  };

  // --------------
  export const requestSendMessageEmailForEvent = async (
    eventId: string,
    payload: IEventMessage
  ): Promise<void> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/actions/sendmessage`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return data;
  };

  // --------------
  export const requestRescheduleNotificationForEvent = async (
    eventId: string,
    payload: IEventMessage,
    oldStartDate?: string,
    oldEndDate?: string,
    newStartDate?: string,
    newEndDate?: string,
  ): Promise<void> => {
    await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/actions/sendmessage-reschedule`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: {
          ...(oldStartDate && { old_start_date: oldStartDate }),
          ...(oldEndDate   && { old_end_date:   oldEndDate }),
          ...(newStartDate && { new_start_date: newStartDate }),
          ...(newEndDate   && { new_end_date:   newEndDate }),
        },
      }
    );
  };

  // --------------
  export const requestSendMessageEmailForCourse = async (
    courseId: string,
    payload: IEventMessage,
    oldStartDate?: string,
    oldEndDate?: string,
    newStartDate?: string,
    newEndDate?: string,
  ): Promise<void> => {
    await httpService.post(
      `${getBaseApiRoute()}/api/courses/${courseId}/actions/sendmessage`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: {
          ...(oldStartDate && { old_start_date: oldStartDate }),
          ...(oldEndDate   && { old_end_date:   oldEndDate }),
          ...(newStartDate && { new_start_date: newStartDate }),
          ...(newEndDate   && { new_end_date:   newEndDate }),
        },
      }
    );
  };

  // --------------
  export const requestSendMessageEmailForShow = async (
    eventId: string,
    showId: string,
    payload: IEventMessage
  ): Promise<void> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/actions/sendmessage`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return data;
  };

  // --------------
  export const getEventParticipantCount = async (
    eventId: string
  ): Promise<{ count: number }> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/participants/count`
    );

    return data;
  };

  // --------------
  export const getShowParticipantCount = async (
    eventId: string,
    showId: string
  ): Promise<{ count: number }> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/participants/count`
    );

    return data;
  };

  // --------------
  export const requestTrialReport = async (
    eventId: string,
    showId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/forms/trial-report`
    );

    return data;
  };

  // --------------
  export const requestJuniorParticipationReport = async (
    eventId: string,
    showId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/forms/junior-participation-report`
    );

    return data;
  };

  // --------------
  export const requestHighInTrialReport = async (
    eventId: string,
    showId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/forms/high-in-trial-report`
    );

    return data;
  };

  // --------------
  export const requestChampionshipPointsReport = async (
    eventId: string,
    showId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/forms/championship-points-report`
    );

    return data;
  };

  // --------------
  export const requestJuniorHandlerCertificate = async (
    eventId: string,
    showId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/forms/junior-handler-certificate`
    );

    return data;
  };

  // --------------
  export const requestEventCatalog = async (
    eventId: string,
    showIds?: string[]
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/event-catalog`,
      showIds?.length ? { show_ids: showIds } : {}
    );

    return data;
  };

  // --------------
  export const requestShowHerdingHighInTrial = async (
    eventId: string,
    showId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/high-in-trial`
    );

    return data;
  };

  // --------------
  export const requestShowHerdingCatalog = async (
    eventId: string,
    showId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/herding-catalog`
    );

    return data;
  };

  // --------------
  export const requestJudgingSchedule = async (
    eventId: string,
    options?: { include_breed?: boolean; include_jump_height?: boolean; include_call_name?: boolean }
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/judging-schedule`,
      options || {}
    );

    return data;
  };

  // --------------
  // One-off, event-specific export — only available for event handle "wyip3b".
  export const requestInterwovenJudgingSchedule = async (
    eventId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/interwoven-judging-schedule`
    );

    return data;
  };

  // --------------
  export const requestUkcEventCounts = async (
    eventId: string,
    options?: { condensed_conformation?: boolean }
  ): Promise<IFormBuildStatus> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/ukc-event-counts`,
      options || {}
    );
    return data;
  };

  export const requestAkcUdxCombinedList = async (
    eventId: string
  ): Promise<IFormBuildStatus> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/akc-udx-combined-list`
    );
    return data;
  };

  // --------------
  export const requestUkcTotalDogReport = async (
    eventId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/ukc-total-dog-report`
    );

    return data;
  };

  // ---------------
  export const getFormStatus = async (
    formId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/forms/${formId}`
    );

    return data;
  };

  // ---------------
  export const downloadForm = async (formId: string): Promise<void> => {
    //
    const response = await httpService.get(
      `${getBaseApiRoute()}/api/forms/${formId}/download`,
      { responseType: "blob" }
    );

    const fileNameHeader = response.headers["content-disposition"];
    const fileName = fileNameHeader
      ? fileNameHeader.replace(/\w+; ?filename=(.*)/, "$1")
      : "form.pdf";
    let blob = new Blob([response.data], {
      type: response.headers["content-type"] as string | undefined,
    });

    let file = URL.createObjectURL(blob);
    let a = document.createElement("a");
    a.href = file;
    a.download = decodeURI(fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  // --------------
  // Returns an URL of the uploaded file
  export const uploadFile = async (file: File): Promise<string> => {
    //
    const formData = new FormData();
    formData.append("file", file);

    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/storage/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return data;
  };

  // ------------------
  // Dog vaccine certificate attachments

  export const addDogAttachment = async (
    dogId: string,
    payload: {
      type: string;
      file_url: string;
      file_name: string;
      file_size: number;
      mime_type: string;
      expiry_date: string;
      notes?: string;
    }
  ): Promise<IDog> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/dogs/${dogId}/attachments`,
      payload
    );
    return data;
  };

  export const removeDogAttachment = async (
    dogId: string,
    fileUrl: string
  ): Promise<IDog> => {
    const { data } = await httpService.delete_(
      `${getBaseApiRoute()}/api/dogs/${dogId}/attachments?file_url=${encodeURIComponent(fileUrl)}`
    );
    return data;
  };

  // ------------------
  // Club Managers can search users
  export const getUsers = async (queryDto?: QueryDto): Promise<IUser[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/users/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // -------------
  export const getTrustedSecretaryReferrals = async (): Promise<
    ITrustedSecretaryReferralRow[]
  > => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/trusted-secretary/referrals`
    );

    return data;
  };

  // -------------
  export const getTrustedSecretaryMetrics =
    async (): Promise<ITrustedSecretaryMetrics> => {
      const { data } = await httpService.get(
        `${getBaseApiRoute()}/api/trusted-secretary/metrics`
      );

      return data;
    };

  // -------------
  export const getAdminTrustedSecretariesReport = async (): Promise<ITrustedSecretaryAdminRow[]> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/admin/trusted-secretaries`
    );

    return data;
  };

  export const getAdminTrustedSecretaryClubs = async (userId: string): Promise<ITrustedSecretaryClubRow[]> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/admin/trusted-secretaries/${userId}/clubs`
    );

    return data;
  };

  // -------------
  // Route for club admins to create a user
  export const createUserByClubManager = async (
    userCreateDto: UserCreateDto
  ): Promise<IUser> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/users`,
      userCreateDto
    );

    return data;
  };

  // -------------
  // Route for club admins to update a user
  export const updateUserByClubManager = async (
    userId: string,
    userUpdateDto: UserUpdateDto
  ): Promise<IUser> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/users/${userId}`,
      userUpdateDto
    );

    return data;
  };

  // -------------
  // Route for users with admin capacities to update other users
  export const updateUserByAdmin = async (
    userId: string,
    userUpdateDto: UserUpdateDto,
    clubId: string
  ): Promise<IUser> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/users/${userId}/admin-update`,
      { ...userUpdateDto, club_id: clubId }
    );

    return data;
  };

  // -------------
  // Route for club admins to get a user by ID
  export const getUserById = async (userId: string): Promise<IUser> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/users/${userId}`
    );

    return data;
  };

  // -------------
  export const createDogByClubManager = async (
    clubId: string,
    dogDto: DogByClubManagerDto
  ): Promise<IDog> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${clubId}/dogs`,
      dogDto
    );

    return data;
  };

  // -------------
  export const getEventScores = async (
    eventId: string,
    queryDto?: QueryDto
  ): Promise<IScore[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // -------------
  // Read-only endpoint for dog owners to view event scores
  export const getEventScoresReadOnly = async (
    eventId: string,
    queryDto?: QueryDto
  ): Promise<IScore[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/actions/search/read-only`,
      queryDto || {}
    );

    return data;
  };

  // -------------
  export const enterNoseworkScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: NoseworkScoreDto
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/nosework`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterFastcatScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: FastcatScoreDto
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/fastcat`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterFastdashScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: any
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/fastdash`,
      scoreDto
    );

    return data;
  };

  // -------------
  // Generic score submission. The `path` suffix is resolved via
  // @eagerdog/scoring-core's resolveApiPath so the web Results tab and the
  // mobile Scoring screens submit to identical endpoints from one source of
  // truth. The per-type enterXScore helpers below remain for existing callers.
  export const enterScore = async (
    eventId: string,
    scoreId: string,
    path: string,
    scoreDto: any
  ): Promise<IScore> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/${path}`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterCatScore = async (
    eventId: string,
    scoreId: string,
    catScore: ICatScore
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/cat`,
      catScore
    );

    return data;
  };

  // -------------
  export const enterFetchScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: FetchScoreDto
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/fetch`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterCountryRatRaceScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: RatRaceScoreDto
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/country-rat-race`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterUrbanRatRaceScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: RatRaceScoreDto
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/urban-rat-race`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterLostAndFoundScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: RatRaceScoreDto
  ): Promise<IScore> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/lost-and-found`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterObedienceScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: ObedienceScoreDto
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/obedience`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterRallyObedienceScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: RallyObedienceScoreDto
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/rally-obedience`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterScentworkScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: ScentworkScoreDto[]
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/scentwork`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterDockJumpingScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: DockJumpingScoreDto
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/dock-jumping`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterShedDogScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: ShedDogScoreDto
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/shed-dog`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterPrecisionCoursingScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: PrecisionCoursingScoreDto
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/precision-coursing`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterWeightPullScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: WeightPullScoreDto
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/weight-pull`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterFarmDogScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: FarmDogScoreDto
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/farm-dog`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterWaterDogScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: WaterDogScoreDto
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/water-dog`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterAgilityScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: AgilityScoreDto
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/agility`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterAkcAgilityScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: AkcAgilityScoreDto
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/akc-agility`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterHerdingScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: HerdingScoreDto
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/herding`,
      scoreDto
    );

    return data;
  };

  export const enterScentScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: ScentScoreDto
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/scent`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterBarnHuntScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: any
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/barn-hunt`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const enterScentDogGamesScore = async (
    eventId: string,
    scoreId: string,
    scoreDto: ScentDogGamesScoreDto
  ): Promise<IScore> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/scent-dog-games`,
      scoreDto
    );

    return data;
  };

  // -------------
  export const getScoresGroupPlacements = async (
    eventId: string,
    scoreId: string,
    scorePlacementDto: ScorePlacementDto
  ): Promise<IScore[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/placements`,
      scorePlacementDto
    );

    return data;
  };

  // -------------
  export const deleteScoreResult = async (
    eventId: string,
    scoreId: string
  ): Promise<IScore> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/delete-result`
    );

    return data;
  };

  // -------------
  export const updateScoreCheckIn = async (
    eventId: string,
    scoreId: string,
    checkedIn: boolean
  ): Promise<IScore> => {
    //
  console.log('[ResultsTab][API] updateScoreCheckIn request', { eventId, scoreId, checkedIn });
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/check-in`,
      { checked_in: checkedIn }
    );
  console.log('[ResultsTab][API] updateScoreCheckIn success', {
    scoreId,
    checked_in: (data as any)?.checked_in,
  });

    return data;
  };

  // -------------
  export const updateScoreComplete = async (
    eventId: string,
    scoreId: string,
    complete: boolean
  ): Promise<IScore> => {
    //
  console.log('[ResultsTab][API] updateScoreComplete request', { eventId, scoreId, complete });
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/complete`,
      { complete: complete }
    );
  console.log('[ResultsTab][API] updateScoreComplete success', {
    scoreId,
    complete: (data as any)?.complete,
  });

    return data;
  };

// -------------
export const updateScoreConflict = async (
  eventId: string,
  scoreId: string,
  conflict: boolean,
  conflictNote?: string
): Promise<IScore> => {
  const { data } = await httpService.put(
    `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/conflict`,
    { conflict, conflict_note: conflictNote }
  );
  return data;
};

// -------------
export const updateScoreScratch = async (
  eventId: string,
  scoreId: string,
  scratched: boolean
): Promise<IScore> => {
  console.log("[ResultsTab][API] updateScoreScratch request", { eventId, scoreId, scratched });
  const { data } = await httpService.put(
    `${getBaseApiRoute()}/api/events/${eventId}/scores/${scoreId}/scratch`,
    { scratched }
  );
  console.log("[ResultsTab][API] updateScoreScratch success", {
    scoreId,
    status: (data as any)?.status,
  });
  return data;
};

// -------------
// UKC Weight Pull event-level "Weigh Ins" (see docs/ukc-weight-pull-weigh-in-redesign.md).
export const getEventWeighIns = async (
  eventId: string
): Promise<IWeightPullWeighIn[]> => {
  const { data } = await httpService.get(
    `${getBaseApiRoute()}/api/events/${eventId}/weight-pull/weigh-ins`
  );
  return data;
};

// -------------
export const updateDogWeighIn = async (
  eventId: string,
  dogId: string,
  dogWeight: number,
  weighedBy?: string
): Promise<IWeightPullWeighIn[]> => {
  const { data } = await httpService.put(
    `${getBaseApiRoute()}/api/events/${eventId}/weight-pull/weigh-ins/${dogId}`,
    { dog_weight: dogWeight, weighed_by: weighedBy }
  );
  return data;
};

  // -------------
  export const bulkUpdateScoreJudge = async (
    eventId: string,
    query: any,
    update: { judge_name: string; judge_number: string }
  ): Promise<void> => {
    await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/bulk-update-judge`,
      { query, update }
    );
  };

  // -------------
  // Keeps show_elements (the "Judges" tab config, and default judge for new
  // registrations) in sync when a whole class tile is moved to a different judge
  // in the Judge Schedule tab. Without this, show_elements keeps pointing at the
  // old judge and new registrations for the class silently default back to them.
  export const updateShowElementJudge = async (
    eventId: string,
    showId: string,
    payload: {
      show_element: string;
      level?: string;
      section?: string;
      judge_name: string;
      judge_number?: string;
    }
  ): Promise<IShow> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/show-elements/judge`,
      payload
    );
    return data;
  };

  // --------------
  export const createClubPaymentMethod = async (
    clubId: string
  ): Promise<{ setup_intent_id: string; client_secret: string | null }> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${clubId}/payment-methods`
    );

    return data;
  };

  // --------------
  export const getClubPaymentMethods = async (
    clubId: string
  ): Promise<any[]> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/payment-methods`
    );

    return data;
  };

  // --------------
  export const deleteClubPaymentMethod = async (
    clubId: string,
    paymentMethodId: string
  ): Promise<void> => {
    //
    await httpService.delete_(
      `${getBaseApiRoute()}/api/clubs/${clubId}/payment-methods/${paymentMethodId}`
    );
  };

  // -------------
  export const getUKCConformationCounts = async (
    eventId: string,
    showId: string,
    queryDto?: QueryDto
  ): Promise<IEventUKCConformationCount[]> => {
    //

    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/${showId}/show-registrations/ukc-conformation-counts`,
      queryDto || {}
    );

    return data;
  };

  // -------------
  export const getAKCConformationSpecialtyCounts = async (
    eventId: string,
    showId: string,
    queryDto?: QueryDto
  ): Promise<any> => {
    //

    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/${showId}/show-registrations/akc-conformation-specialty-counts`,
      queryDto || {}
    );

    return data;
  };

  // -------------
  export const getAKCConformationCounts = async (
    eventId: string,
    showId: string,
    queryDto?: QueryDto
  ): Promise<IEventAKCConformationCount[]> => {
    //

    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/${showId}/show-registrations/akc-conformation-counts`,
      queryDto || {}
    );

    return data;
  };

  // -------------
  export const getFastCATTitleCounts = async (
    eventId: string,
    showId: string,
    queryDto?: QueryDto
  ): Promise<{ title: string; count: number }[]> => {
    //

    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/${showId}/show-registrations/fastcat-title-counts`,
      queryDto || {}
    );

    return data;
  };

  // ---------------
  // Get Stripe account details
  export const getStripeAccount = async (clubId: string): Promise<any> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/stripe/account`
    );
    return data;
  };

  // ---------------
  // Get Stripe Connect OAuth URL for connecting a Standard account
  export const getStripeConnectUrl = async (
    clubId: string,
    redirectUri: string
  ): Promise<{ url: string }> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/stripe-connect-url`,
      { params: { redirect_uri: redirectUri } }
    );
    return data;
  };

  // ---------------
  // Exchange OAuth code for a Standard account connection
  export const exchangeStripeConnectCode = async (
    clubId: string,
    code: string
  ): Promise<{ success: boolean }> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${clubId}/stripe-connect/exchange`,
      { code }
    );
    return data;
  };

  // ---------------
  // Disconnect a Standard Stripe account
  export const disconnectStripeAccount = async (
    clubId: string
  ): Promise<{ success: boolean }> => {
    const { data } = await httpService.delete_(
      `${getBaseApiRoute()}/api/clubs/${clubId}/stripe-disconnect`
    );
    return data;
  };

  // -------------
  // Bulk Discount Admin Methods
  // -------------

  // Generate bulk discount codes
  export const generateBulkDiscountCodes = async (
    dto: GenerateBulkCodesDto
  ): Promise<{ batch_id: string; codes: string[] }> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/admin/bulk-discounts/generate`,
      dto
    );

    return data;
  };

  // Get all bulk discount batches
  export const getBulkDiscountBatches = async (): Promise<any[]> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/admin/bulk-discounts/batches`
    );

    return data;
  };

  // Get batch details
  export const getBulkDiscountBatchDetails = async (
    batchId: string
  ): Promise<any> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/admin/bulk-discounts/batches/${batchId}`
    );

    return data;
  };

  // Get unused codes from batch (for export)
  export const getBulkDiscountBatchCodes = async (
    batchId: string,
    limit?: number
  ): Promise<string[]> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/admin/bulk-discounts/batches/${batchId}/codes`,
      { params: { limit } }
    );

    return data;
  };

  // Expire a batch
  export const expireBulkDiscountBatch = async (
    batchId: string
  ): Promise<{ batch_id: string; expired_count: number }> => {
    const { data } = await httpService.delete_(
      `${getBaseApiRoute()}/api/admin/bulk-discounts/batches/${batchId}`
    );

    return data;
  };

  // Admin: force-reset a user's password by email
  export const adminResetPassword = async (email: string, new_password: string): Promise<{ message: string }> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/auth/admin-reset-password`,
      { email, new_password }
    );
    return data;
  };

  // Get usage analytics
  export const getBulkDiscountAnalytics = async (): Promise<any> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/admin/bulk-discounts/analytics`
    );

    return data;
  };

  // Company metrics (system admin)
  export const getCompanyMetrics = async (
    section: "growth" | "financials" | "clubs",
    params: { from: string; to: string; currency: string; payments: string }
  ): Promise<any> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/admin/metrics/${section}?${new URLSearchParams(params).toString()}`
    );

    return data;
  };

  // Get all bulk discount codes (for table)
  export const getAllBulkDiscountCodes = async (
    queryDto?: QueryDto
  ): Promise<IBulkDiscountCode[]> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/admin/bulk-discounts/codes`,
      queryDto || {}
    );

    return data;
  };

  // -------------
  // Courses
  // -------------
  // The current user must be the club manager
  export const createCourse = async (
    courseDto: CourseDto & { club_id?: string }
  ): Promise<ICourse> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/courses`,
      courseDto
    );

    return data;
  };

  // -------------
  export const updateCourse = async (
    courseId: string,
    courseDto: CourseDto
  ): Promise<ICourse> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/courses/${courseId}`,
      courseDto
    );

    return data;
  };

  // -------------
  export const rescheduleEvent = async (
    eventId: string,
    deltaDays: number,
    notifyRegistrants = false
  ): Promise<IEvent> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/reschedule`,
      { delta_days: deltaDays, notify_registrants: notifyRegistrants }
    );
    return data;
  };

  // -------------
  export const rescheduleCourse = async (
    courseId: string,
    deltaDays: number,
    notifyRegistrants = false,
    fromSessionIndex?: number,
    toSessionIndex?: number
  ): Promise<ICourse> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/courses/${courseId}/reschedule`,
      {
        delta_days: deltaDays,
        notify_registrants: notifyRegistrants,
        ...(fromSessionIndex !== undefined && { from_session_index: fromSessionIndex }),
        ...(toSessionIndex !== undefined && { to_session_index: toSessionIndex }),
      }
    );
    return data;
  };

  // -------------
  // public
  export const getCourseSummaryForHandle = async (
    handle: string
  ): Promise<ICourseSummary> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/courses/${handle}`
    );

    return data;
  };

  // -----------------
  // Course documents
  // -----------------
  export const getCourseDocuments = async (courseId: string): Promise<ICourseDocument[]> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/courses/${courseId}/documents`
    );
    return data;
  };

  export const createCourseDocument = async (
    courseId: string,
    document: CourseDocumentDto
  ): Promise<ICourseDocument[]> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/courses/${courseId}/documents`,
      document
    );
    return data;
  };

  export const updateCourseDocument = async (
    courseId: string,
    documentId: string,
    document: UpdateCourseDocumentDto
  ): Promise<ICourseDocument[]> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/courses/${courseId}/documents/${encodeURIComponent(documentId)}`,
      document
    );
    return data;
  };

  export const deleteCourseDocument = async (
    courseId: string,
    documentId: string
  ): Promise<ICourseDocument[]> => {
    const { data } = await httpService.delete_(
      `${getBaseApiRoute()}/api/courses/${courseId}/documents/${encodeURIComponent(documentId)}`
    );
    return data;
  };

  // -------------
  // All courses (public route)
  export const getCourses = async (
    queryDto?: QueryDto
  ): Promise<ICourseSummary[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/courses/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // -------------
  // Club-scoped courses (authenticated, for club managers)
  export const getPrivateCourses = async (
    queryDto?: QueryDto,
    club_id?: string
  ): Promise<ICourseSummary[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/courses/actions/search/private`,
      { query: queryDto, club_id }
    );

    return data;
  };

  //
  // ----------------
  export const getEventAddOns = async (
    eventId: string,
    queryDto?: QueryDto
  ): Promise<IAddOn[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/add-ons/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // ----------------
  export const createEventAddOn = async (
    eventId: string,
    addOnDto: AddOnDto
  ): Promise<IAddOn> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/add-ons`,
      addOnDto
    );

    return data;
  };

  // ----------------
  export const updateEventAddOn = async (
    eventId: string,
    addOnId: string,
    addOnDto: AddOnDto
  ): Promise<IAddOn> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/add-ons/${addOnId}`,
      addOnDto
    );

    return data;
  };

  // ----------------
  export const deleteEventAddOn = async (
    eventId: string,
    addOnId: string
  ): Promise<void> => {
    //
    await httpService.delete_(
      `${getBaseApiRoute()}/api/events/${eventId}/add-ons/${addOnId}`
    );
  };

  // -----------------
  export const getEventAddOnRegistrations = async (
    eventId: string,
    queryDto?: QueryDto
  ): Promise<IAddOnRegistration[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/add-on-registrations/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // Request AKC Results XML generation
  export const requestAkcResultsXml = async (
    eventId: string
  ): Promise<{ _id: string }> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/forms/admin/akc-results/${eventId}`
    );

    return data;
  };

  // Get user's club capacities for context switching
  export const getUserCapacities = async (): Promise<{
    capacities: Array<{
      club_id: string;
      club_name: string;
      logo_url?: string;
      state?: string;
      country?: string;
      capacities: string[];
    }>;
  }> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/users/me/capacities`
    );

    return data;
  };

  // Add user with capacity to a club
  export const addUserWithCapacity = async (
    clubId: string,
    userData: {
      email: string;
      first_name: string;
      last_name: string;
      capacity: "volunteer" | "member" | "admin";
    }
  ): Promise<{ user_id: string; message: string }> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${clubId}/capacities/users`,
      userData
    );

    return data;
  };

  // Get club capacities
  export const getClubCapacities = async (
    clubId: string,
    capacity?: string,
    page: number = 1,
    limit: number = 1000,
    capacities?: string[]
  ): Promise<{
    capacities: Array<{
      _id: string;
      user_id: string;
      user: {
        first_name: string;
        last_name: string;
        email: string;
      };
      capacities: string[];
      created_at: string;
    }>;
    total: number;
  }> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (capacity) {
      params.append("capacity", capacity);
    }
    if (capacities && capacities.length > 0) {
      params.append("capacities", capacities.join(","));
    }

    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/capacities?${params.toString()}`
    );

    return data;
  };

  export const addClubCapacity = async (
    clubId: string,
    userId: string,
    capacity: string
  ): Promise<void> => {
    await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${clubId}/capacities`,
      { user_id: userId, capacity }
    );
  };

  export const removeClubCapacity = async (
    clubId: string,
    userId: string,
    capacity: string
  ): Promise<void> => {
    await httpService.delete_(
      `${getBaseApiRoute()}/api/clubs/${clubId}/capacities/${userId}/${capacity}`
    );
  };

  // Removes every capacity/role a user has for a club in one atomic call
  // (used by "Remove Contact"), instead of deleting each capacity one at a
  // time.
  export const removeAllClubCapacities = async (
    clubId: string,
    userId: string
  ): Promise<void> => {
    await httpService.delete_(
      `${getBaseApiRoute()}/api/clubs/${clubId}/capacities/${userId}`
    );
  };

  // --------------- Gate Stewards ---------------
  export const getGateStewards = async (
    eventId: string
  ): Promise<IGateSteward[]> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/gate-stewards`
    );
    return data;
  };

  export const addGateSteward = async (
    eventId: string,
    userId: string,
    extra?: { first_name?: string; last_name?: string; email?: string }
  ): Promise<IGateSteward[]> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/gate-stewards`,
      { user_id: userId, ...(extra || {}) }
    );
    return data;
  };

  export const removeGateSteward = async (
    eventId: string,
    userId: string
  ): Promise<IGateSteward[]> => {
    const { data } = await httpService.delete_(
      `${getBaseApiRoute()}/api/events/${eventId}/gate-stewards/${userId}`
    );
    return data;
  };

  export const getMyGateStewardEvents = async (): Promise<IEvent[]> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/me/gate-steward-events`
    );
    return data;
  };

  // -----------------
  // Hotels
  // -----------------
  export const getEventHotels = async (eventId: string): Promise<IEventHotel[]> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/hotels`
    );
    return data;
  };

  export const createEventHotel = async (
    eventId: string,
    hotel: EventHotelDto
  ): Promise<IEventHotel[]> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/hotels`,
      hotel
    );
    return data;
  };

  export const updateEventHotel = async (
    eventId: string,
    hotelId: string,
    hotel: EventHotelDto
  ): Promise<IEventHotel[]> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/hotels/${hotelId}`,
      hotel
    );
    return data;
  };

  export const deleteEventHotel = async (
    eventId: string,
    hotelId: string
  ): Promise<IEventHotel[]> => {
    const { data } = await httpService.delete_(
      `${getBaseApiRoute()}/api/events/${eventId}/hotels/${hotelId}`
    );
    return data;
  };

  // -----------------
  // Documents
  // -----------------
  export const getEventDocuments = async (eventId: string): Promise<IEventDocument[]> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/documents`
    );
    return data;
  };

  export const createEventDocument = async (
    eventId: string,
    document: EventDocumentDto
  ): Promise<IEventDocument[]> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/documents`,
      document
    );
    return data;
  };

  export const updateEventDocument = async (
    eventId: string,
    documentId: string,
    document: UpdateEventDocumentDto
  ): Promise<IEventDocument[]> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/documents/${documentId}`,
      document
    );
    return data;
  };

  export const deleteEventDocument = async (
    eventId: string,
    documentId: string
  ): Promise<IEventDocument[]> => {
    const { data } = await httpService.delete_(
      `${getBaseApiRoute()}/api/events/${eventId}/documents/${documentId}`
    );
    return data;
  };

  export const getClubCapacityMetrics = async (
    clubId: string
  ): Promise<{
    participants: number;
    volunteers: number;
    members: number;
    admins: number;
    total: number;
  }> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/capacities/metrics`
    );

    return data;
  };

  export const getClubCapacitySummary = async (
    clubId: string
  ): Promise<{
    participant: number;
    volunteer: number;
    member: number;
    admin: number;
    follower: number;
    donor: number;
    total: number;
  }> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/capacities/summary`
    );

    return data;
  };

  export const searchClubUsersByEmail = async (
    clubId: string,
    email: string,
    capacities: string[] = ["volunteer", "member", "admin"],
    page: number = 1,
    limit: number = 20
  ): Promise<{
    users: Array<{
      user_id: string;
      capacities: string[];
      user: {
        first_name?: string;
        last_name?: string;
        email?: string;
      };
    }>;
    total: number;
  }> => {
    const params = new URLSearchParams({
      email,
      capacities: capacities.join(","),
      page: page.toString(),
      limit: limit.toString(),
    });

    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/capacities/search-users?${params.toString()}`
    );

    return data;
  };

  // Send bulk message to filtered contacts
  export const sendBulkMessageToContacts = async (
    clubId: string,
    subject: string,
    body: string,
    capacityFilter?: string[]
  ): Promise<{ sent: number; message: string }> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${clubId}/capacities/send-message`,
      {
        subject,
        body,
        capacityFilter,
      }
    );

    return data;
  };

  // Send individual message to contact
  export const sendIndividualMessageToContact = async (
    clubId: string,
    userId: string,
    subject: string,
    body: string
  ): Promise<{ message: string }> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${clubId}/capacities/${userId}/send-message`,
      {
        subject,
        body,
      }
    );

    return data;
  };

  // -----------------
  // Club Bans
  export const getClubBans = async (
    clubId: string,
    page: number = 1,
    limit: number = 50,
    includeExpired: boolean = false
  ): Promise<{
    bans: Array<{
      _id: string;
      club_id: string;
      user_id: string;
      reason: string;
      notes?: string;
      banned_by: string;
      banned_at: string;
      expires_at?: string;
      user: {
        _id: string;
        first_name?: string;
        last_name?: string;
        display_name: string;
        email: string;
      };
      banned_by_user?: {
        _id: string;
        display_name: string;
      };
    }>;
    total: number;
  }> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      includeExpired: includeExpired.toString(),
    });

    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/bans?${params.toString()}`
    );

    return data;
  };

  export const searchUsersForBan = async (
    clubId: string,
    searchTerm: string
  ): Promise<
    Array<{
      _id: string;
      first_name?: string;
      last_name?: string;
      display_name: string;
      email: string;
      is_banned: boolean;
    }>
  > => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/bans/search?q=${encodeURIComponent(searchTerm)}`
    );

    return data;
  };

  export const banUser = async (
    clubId: string,
    userId: string,
    reason: string,
    notes?: string,
    expiresAt?: string
  ): Promise<any> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${clubId}/bans`,
      { user_id: userId, reason, notes, expires_at: expiresAt }
    );

    return data;
  };

  export const unbanUser = async (
    clubId: string,
    userId: string
  ): Promise<{ success: boolean }> => {
    const { data } = await httpService.delete_(
      `${getBaseApiRoute()}/api/clubs/${clubId}/bans/${userId}`
    );

    return data;
  };

  export const checkIfUserIsBanned = async (
    clubId: string
  ): Promise<{ is_banned: boolean }> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/bans/me`
    );

    return data;
  };

  export const checkIfSpecificUserIsBanned = async (
    clubId: string,
    userId: string
  ): Promise<{ is_banned: boolean }> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/bans/check/${userId}`
    );

    return data;
  };

  // -----------------
  export const getDocumentSignedUrl = async (
    formBuildStatusId: string
  ): Promise<string> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/documents/${formBuildStatusId}`
    );

    return data;
  };

  // ----------------
  export const requestRunOrder = async (
    eventId: string,
    showId: string,
    ring: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/run-order`,
      { show_id: showId, ring }
    );

    return data;
  };

  // ----------------
  export const requestMeasurementReport = async (
    eventId: string,
    showId: string
  ): Promise<IFormBuildStatus> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/forms/measurement-report`,
      { show_id: showId }
    );

    return data;
  };

  // ----------------
  export const searchEventScores = async (
    eventId: string,
    queryDto?: QueryDto
  ): Promise<IScore[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/scores/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // ----------------
  export const getTariffPlans = async (): Promise<ITariffPlan[]> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/tariff-plans/index`
    );

    return data;
  };

  // ----------------
  export const getTariffPlan = async (
    tariffPlanId: string
  ): Promise<ITariffPlan | null> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/tariff-plans/${tariffPlanId}/show`
    );

    return data;
  };

  // ----------------
  export const getUserSubscriptionPlan = async (
    clubId?: string
  ): Promise<ITariffPlanSubscription | null> => {
    //
    const params = clubId ? { club_id: clubId } : {};
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/tariff-plans/subscription`,
      { params }
    );

    return data;
  };

  // ----------------
  export const getUserSubscriptionPaymentError = async (): Promise<
    IStripePaymentError | undefined
  > => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/tariff-plans/subscription/payment-error`
    );

    return data;
  };

  // ----------------
  export const updateUserSubscriptionPlan = async (
    subscriptionDto: UpdateTariffPlanSubscriptionDto
  ): Promise<IStripeSubscription> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/tariff-plans/subscription`,
      subscriptionDto
    );

    return data;
  };

  // ----------------
  export const reactivateUserSubscriptionPlan =
    async (): Promise<IStripeSubscription | null> => {
      const { data } = await httpService.post(
        `${getBaseApiRoute()}/api/tariff-plans/subscription/reactivate`
      );

      return data;
    };

  // ----------------
  export const cancelUserSubscriptionPlan =
    async (): Promise<IStripeSubscription | null> => {
      //
      const { data } = await httpService.post(
        `${getBaseApiRoute()}/api/tariff-plans/subscription/cancel`
      );

      return data;
    };

  // ----------------
  export const getUserPaymentMethods = async (
    customerId: string
  ): Promise<IStripePaymentMethod[]> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/users/cards/payment-methods?customer_id=${customerId}`
    );

    return data;
  };

  // ----------------
  export const detachUserPaymentMethod = async (
    paymentMethodId: string
  ): Promise<IStripePaymentMethod> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/users/payment-method/${paymentMethodId}/detach`
    );

    return data;
  };

  // ----------------
  export const createSetupIntent = async (
    setupIntentDto: CreateSetupIntentDto
  ): Promise<{ setup_intent_id: string; client_secret: string | null }> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/users/setup-intent`,
      setupIntentDto
    );

    return data;
  };

  // ----------------
  export const ensureStripeCustomer = async (): Promise<{ stripe_customer_id: string }> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/users/me/ensure-customer`
    );
    return data;
  };

  // ----------------
  export const getSelfPaymentMethods = async (): Promise<IStripePaymentMethod[]> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/users/me/payment-methods`
    );
    return data;
  };

  // ----------------
  export const getSubscriptionStatus = async (): Promise<{
    has_subscription: boolean;
    status: string | null;
    trial_ends_at: Date | null;
    cancel_at: Date | null;
    next_invoice_at: Date | null;
    has_dog_profile_access: boolean;
    has_past_results_access: boolean;
  }> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/tariff-plans/subscription/status`
    );

    return data;
  };

  // ----------------
  export const syncSubscriptionFeatures = async (): Promise<{
    has_dog_profile_access: boolean;
    has_past_results_access: boolean;
    subscription_status: string | null;
  }> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/tariff-plans/subscription/sync-features`
    );

    return data;
  };

  // ----------------
  export const createCheckoutSession = async (
    checkoutSessionDto: CreateCheckoutSessionDto
  ): Promise<any> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/users/checkout-session`,
      checkoutSessionDto
    );

    return data;
  };

  // ----------------
  export const getCheckoutSession = async (sessionId: string): Promise<any> => {
    //
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/users/checkout-session?session_id=${sessionId}`
    );

    return data;
  };

  // ----------------
  export const getSubscriptionInvoices = async (
    clubId?: string
  ): Promise<IStripeInvoice[]> => {
    //
    const params = clubId ? { club_id: clubId } : {};
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/tariff-plans/subscription/invoices`,
      { params }
    );

    return data.data;
  };

  // Get user's wallet (points for all clubs)
  export const getUserWallet = async (): Promise<{
    user_id: string;
    eagerdog_points: number;
    club_point_balances: Array<{
      club_id: string;
      points: number;
    }>;
    clubs: Array<{
      _id: string;
      club_name: string;
      points: number;
    }>;
    total_points: number;
  }> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/wallets/me`
    );
    return data;
  };

  // Get another user's club points (for behalf registration)
  export const getUserClubPoints = async (
    userId: string,
    clubId: string
  ): Promise<{ points: number; dollarsValue: number }> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/wallets/users/${userId}/clubs/${clubId}/points`
    );
    return data;
  };

  //
  // ---------------
  // Course registration - calculate the payment summary
  // Currently only dog owners can register dogs
  export const getCourseRegistrationPaymentSummary = async (
    courseId: string,
    registrationDto: CourseRegistrationCreateDto
  ): Promise<ITransactionPaymentSummary> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/courses/${courseId}/registration-payment-summary`,
      registrationDto
    );

    const {
      account_number,
      currency,
      amount_multiplier,
      calculated_base_amount,
      calculated_discount_amount,
      calculated_application_fee,
      calculated_processing_fee,
      calculated_processing_tax,
      calculated_total_amount,
      club_points_redeemed,
      club_points_discount_amount,
      details,
      add_ons_details,
    } = data as ITransactionAmounts & { account_number: string } & {
      details: ITransactionCourseDogDetails[];
      add_ons_details?: ITransactionAddOnDetails[];
      club_points_redeemed?: number;
      club_points_discount_amount?: number;
    };

    return {
      account_number,
      currency,
      base_amount: calculated_base_amount * amount_multiplier,
      discount: calculated_discount_amount * amount_multiplier,
      calculated_application_fee,
      calculated_processing_fee,
      calculated_processing_tax,
      fees:
        (calculated_application_fee +
          calculated_processing_fee +
          calculated_processing_tax) *
        amount_multiplier,
      total_amount: calculated_total_amount * amount_multiplier,
      club_points_redeemed,
      club_points_discount_amount,
      details,
      add_ons_details,
    };
  };

  // ---------------
  // Course registration
  export const createCourseRegistrationPaymentIntent = async (
    courseId: string,
    registrationDto: CourseRegistrationCreateDto
  ): Promise<ICourseRegistrationResponse | null> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/courses/${courseId}/registrations`,
      registrationDto
    );

    return data;
  };

  export const getCourseWaitlist = async (courseId: string, waitlistId: string): Promise<ICourseWaitlist> => {
    const { data } = await httpService.get(`${getBaseApiRoute()}/api/courses/${courseId}/waitlist/${waitlistId}`);
    return data;
  };

  export const searchCourseWaitlist = async (courseId: string): Promise<ICourseWaitlist[]> => {
    const { data } = await httpService.post(`${getBaseApiRoute()}/api/courses/${courseId}/waitlist/actions/search`, {});
    return data;
  };

  export const approveCourseWaitlist = async (courseId: string, waitlistId: string): Promise<ICourseWaitlist> => {
    const { data } = await httpService.post(`${getBaseApiRoute()}/api/courses/${courseId}/waitlist/${waitlistId}/approve`, {});
    return data;
  };

  export const declineCourseWaitlist = async (courseId: string, waitlistId: string): Promise<ICourseWaitlist> => {
    const { data } = await httpService.post(`${getBaseApiRoute()}/api/courses/${courseId}/waitlist/${waitlistId}/decline`, {});
    return data;
  };

  export const leaveCourseWaitlist = async (courseId: string, waitlistId: string): Promise<void> => {
    await httpService.post(`${getBaseApiRoute()}/api/courses/${courseId}/waitlist/${waitlistId}/leave`, {});
  };

  // ---------------
  // Course registration - finalize a free (points-covered, $0) transaction.
  // Paid transactions are finalized via Stripe; free ones are processed here.
  export const processCourseRegistrationTransaction = async (
    courseId: string,
    transactionId: string
  ): Promise<void> => {
    //
    await httpService.post(
      `${getBaseApiRoute()}/api/courses/${courseId}/transactions/${transactionId}/actions/process`,
      {}
    );
  };

  // ---------------
  // Event registration - calculate the payment summary
  // Currently only dog owners can register dogs.
  // null is returned in case of "manual" registration (not supported currently)
  export const createCourseRegistrationByClubManager = async (
    courseId: string,
    registrationDto: CourseRegistrationCreateDto
  ): Promise<ITransaction> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/courses/${courseId}/registrations-by-club-manager`,
      registrationDto
    );

    return data;
  };

  // ----------------
  // Protected route - club managers can view the event registrations
  export const getRegisteredCourseDogsByCurrentUser = async (
    courseId: string
  ): Promise<IDog[]> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/courses/${courseId}/registered-dogs/actions/search`,
      {}
    );

    return data;
  };

  export const getCourseRegistrations = async (
    courseId: string,
    queryDto?: QueryDto
  ): Promise<ICourseRegistration[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/courses/${courseId}/registrations/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // ----------------
  // Protected route - club managers can view the event registrations
  export const getCourseSessionRegistrations = async (
    courseId: string,
    queryDto?: QueryDto
  ): Promise<ICourseSessionRegistration[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/courses/${courseId}/session-registrations/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // ------------------
  export const requestCourseSessionRosterExport = async (
    courseId: string
  ): Promise<IFormBuildStatus> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/courses/${courseId}/session-registrations/roster-export`
    );
    return data;
  };

  // ------------------
  export const updateCourseSessionRegistrationStatus = async (
    courseId: string,
    registrationId: string,
    statusDto: CourseSessionRegistrationStatusDto
  ): Promise<ICourseSessionRegistration> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/courses/${courseId}/session-registrations/${registrationId}/status`,
      statusDto
    );

    return data;
  };

  // ------------------
  export const deleteCourseSessionRegistration = async (
    courseId: string,
    registrationId: string,
    creditPoints?: number
  ): Promise<{ credit_applied: boolean }> => {
    //
    const { data } = await httpService.delete_(
      `${getBaseApiRoute()}/api/courses/${courseId}/session-registrations/${registrationId}`,
      creditPoints && creditPoints > 0 ? { data: { credit_points: creditPoints } } : undefined
    );

    return data;
  };

  // ----------------
  export const getCourseTransactions = async (
    courseId: string,
    queryDto?: QueryDto
  ): Promise<ITransactionUserSummary[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/courses/${courseId}/transactions/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // ----------------
  export const refundCourseTransaction = async (
    courseId: string,
    transactionId: string,
    refundDto: TransactionRefundDto
  ): Promise<void> => {
    //
    await httpService.post(
      `${getBaseApiRoute()}/api/courses/${courseId}/transactions/${transactionId}/actions/refund`,
      refundDto
    );
  };

  // Refund store transaction
  export const refundStoreTransaction = async (
    clubId: string,
    transactionId: string,
    refundDto: TransactionRefundDto
  ): Promise<void> => {
    await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${clubId}/store/transactions/${transactionId}/actions/refund`,
      refundDto
    );
  };

  // ----------------
  // Opt-in to club communications
  export const optInToClub = async (clubId: string): Promise<IUser> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/users/me/clubs/${clubId}/opt-in`
    );
    return data;
  };

  // ----------------
  // Opt-out of club communications
  export const optOutOfClub = async (clubId: string): Promise<IUser> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/users/me/clubs/${clubId}/opt-out`
    );
    return data;
  };

  // ----------------
  // Get user's clubs (favorites + opted-in)
  export const getUserClubs = async (): Promise<{
    clubs: Array<{
      club_id: string;
      club_name: string;
      location: string;
      logo_url?: string;
      cover_image_url?: string;
      is_favorite: boolean;
      is_opted_in: boolean;
    }>;
  }> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/users/me/clubs`
    );
    console.log(data);
    return data;
  };

  // ----------------
  // Get opt-in counts for club contacts
  export const getClubOptInCounts = async (
    clubId: string,
    capacityFilter?: string[]
  ): Promise<{ total: number; optedIn: number; optedOut: number }> => {
    const params =
      capacityFilter && capacityFilter.length > 0
        ? `?capacityFilter=${capacityFilter.join(",")}`
        : "";
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/clubs/${clubId}/capacities/opt-in-counts${params}`
    );
    return data;
  };

  // ----------------
  // Create Stripe Payment Intent for club donation (Direct charge)
  export const createClubDonationIntent = async (
    clubId: string,
    intentDto: ClubDonationIntentDto
  ): Promise<{
    payment_intent_id: string;
    client_secret: string;
    account_number: string;
  }> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${clubId}/donate/intent`,
      intentDto
    );
    return data;
  };

  // ----------------
  export const updateClubDonationIntent = async (
    clubId: string,
    paymentIntentExternalId: string,
    intentDto: ClubDonationIntentDto
  ): Promise<{
    payment_intent_id: string;
    client_secret: string;
    account_number: string;
  }> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/clubs/${clubId}/donate/intent/${paymentIntentExternalId}`,
      intentDto
    );
    return data;
  };

  // ----------------
  export const createClubDonation = async (
    clubId: string,
    donationDto: ClubDonationDto
  ): Promise<ITransaction> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/clubs/${clubId}/donate`,
      donationDto
    );
    return data;
  };

  // ----------------
  export const duplicateEvent = async (
    eventId: string,
    duplicateEventDto: DuplicateEventDto
  ): Promise<IEvent> => {
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/events/${eventId}/duplicate`,
      duplicateEventDto
    );
    return data;
  };

  // ----------------
  export const getCourseDiscounts = async (
    courseId: string,
    queryDto?: QueryDto
  ): Promise<IDiscount[]> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/courses/${courseId}/discounts/actions/search`,
      queryDto || {}
    );

    return data;
  };

  // ----------------
  export const createCourseDiscount = async (
    courseId: string,
    discountDto: DiscountDto
  ): Promise<IDiscount> => {
    //
    const { data } = await httpService.post(
      `${getBaseApiRoute()}/api/courses/${courseId}/discounts`,
      discountDto
    );

    return data;
  };

  // ----------------
  export const updateCourseDiscount = async (
    courseId: string,
    discountId: string,
    discountDto: DiscountDto
  ): Promise<IDiscount> => {
    //
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/courses/${courseId}/discounts/${discountId}`,
      discountDto
    );

    return data;
  };

  // ----------------
  export const deleteCourseDiscount = async (
    courseId: string,
    discountId: string
  ): Promise<void> => {
    //
    await httpService.delete_(
      `${getBaseApiRoute()}/api/courses/${courseId}/discounts/${discountId}`
    );
  };

  // ── UKC Conformation Results ──────────────────────────────────────────────

  export const getConformationEntrySummary = async (
    eventId: string,
    showId: string
  ): Promise<{ show: IShow; scores: IScore[] }> => {
    const { data } = await httpService.get(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/conformation/entry-summary`
    );
    return data;
  };

  export const saveConformationBreedResults = async (
    eventId: string,
    showId: string,
    breedResult: IConformationBreedResult
  ): Promise<IShow> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/conformation/breed-results`,
      breedResult
    );
    return data;
  };

  export const saveConformationGroupResults = async (
    eventId: string,
    showId: string,
    groupResult: IConformationGroupResult
  ): Promise<IShow> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/conformation/group-results`,
      groupResult
    );
    return data;
  };

  export const saveConformationShowResults = async (
    eventId: string,
    showId: string,
    showAwards: IConformationShowAwards
  ): Promise<IShow> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/conformation/show-results`,
      showAwards
    );
    return data;
  };

  export const saveConformationNonLicensedBreedResults = async (
    eventId: string,
    showId: string,
    breedResult: IConformationNonLicensedBreedResult
  ): Promise<IShow> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/conformation/non-licensed-breed-results`,
      breedResult
    );
    return data;
  };

  export const saveConformationJuniorResults = async (
    eventId: string,
    showId: string,
    junior: IJuniorShowmanshipResults
  ): Promise<IShow> => {
    const { data } = await httpService.put(
      `${getBaseApiRoute()}/api/events/${eventId}/shows/${showId}/conformation/junior-results`,
      junior
    );
    return data;
  };

}
